export default {
  translation: {
    // Common
    "app.name": "Give Protocol",
    "app.tagline": "Hạ tầng minh bạch, không biên giới cho lòng hào phóng.",
    "common.skipToMainContent": "Bỏ qua đến nội dung chính",
    "common.cancel": "Hủy",
    "common.edit": "Chỉnh sửa",
    "common.delete": "Xóa",
    "common.creating": "Đang tạo...",
    "common.unknown": "Không xác định",
    "common.notAvailable": "N/A",

    // Navigation
    "nav.browse": "Duyệt tổ chức từ thiện",
    "nav.opportunities": "Cơ hội tình nguyện",
    "nav.contributions": "Theo dõi đóng góp",
    "nav.governance": "Quản trị",
    "nav.dashboard": "Bảng điều khiển Give",
    "nav.about": "Giới thiệu",
    "nav.docs": "Tài liệu",
    "nav.legal": "Pháp lý",
    "nav.launchApp": "Khởi động ứng dụng",

    // FAQ page (GIV-988)
    "faq.title": "Câu hỏi thường gặp",
    "faq.subtitle":
      "Tất cả những gì bạn cần biết về quyên góp, tình nguyện và tính minh bạch của blockchain.",

    // Settings
    "settings.title": "Cài đặt",
    "settings.language": "Ngôn ngữ",
    "settings.currency": "Tiền tệ",

    // Auth
    "auth.login": "Đăng nhập",
    "auth.register": "Tạo tài khoản",
    "auth.logout": "Đăng xuất",
    "auth.forgotPassword": "Quên mật khẩu?",

    // Dashboard
    "dashboard.title": "Bảng điều khiển Give",
    "dashboard.subtitle": "Theo dõi quyên góp và đóng góp tình nguyện của bạn",
    "dashboard.totalDonations": "Tổng quyên góp",
    "dashboard.volunteerHours": "Giờ tình nguyện",
    "dashboard.skillsEndorsed": "Kỹ năng được xác nhận",
    "dashboard.contributions": "Đóng góp",
    "dashboard.yourTotalDonated": "Tổng bạn đã quyên góp",
    "dashboard.yourVolunteerHours": "Giờ tình nguyện của bạn",
    "dashboard.yourSkillsEndorsed": "Kỹ năng được xác nhận của bạn",
    "dashboard.impactGrowth": "Tăng trưởng tác động",
    "dashboard.charitiesSupported": "Tổ chức từ thiện được hỗ trợ",

    // Charity
    "charity.dashboard": "Bảng điều khiển tổ chức từ thiện",
    "charity.subtitle": "Quản lý quyên góp và chương trình tình nguyện của bạn",
    "charity.activeVolunteers": "Tình nguyện viên hoạt động",
    "charity.transactions": "Giao dịch",
    "charity.volunteers": "Giờ tình nguyện",
    "charity.applications": "Đơn đăng ký",
    "charity.totalReceived": "Tổng đã nhận",
    "charity.equityPoolValue": "Giá trị quỹ cổ phần",
    "charity.availableBalance": "Số dư khả dụng",

    // Contributions
    "contributions.date": "Ngày",
    "contributions.type": "Loại",
    "contributions.organization": "Tổ chức",
    "contributions.details": "Chi tiết",
    "contributions.status": "Trạng thái",
    "contributions.verification": "Xác minh",
    "contributions.export": "Xuất CSV",

    // Volunteer
    "volunteer.opportunities": "Cơ hội tình nguyện",
    "volunteer.searchOpportunities": "Tìm kiếm cơ hội...",
    "volunteer.selectSkill": "Chọn kỹ năng",
    "volunteer.selectType": "Chọn loại",
    "volunteer.selectLanguage": "Chọn ngôn ngữ",
    "volunteer.allSkills": "Tất cả kỹ năng",
    "volunteer.allTypes": "Tất cả loại",
    "volunteer.allLanguages": "Tất cả ngôn ngữ",
    "volunteer.applyNow": "Đăng ký ngay",
    "volunteer.noOpportunitiesFound":
      "Không tìm thấy cơ hội phù hợp với tiêu chí của bạn.",
    "volunteer.verify": "Xác minh giờ",
    "volunteer.verifying": "Đang xác minh...",
    "volunteer.reject": "Từ chối",
    "volunteer.accept": "Chấp nhận",
    "volunteer.processing": "Đang xử lý...",
    "volunteer.hours": "giờ vào",
    "volunteer.description": "Mô tả",
    "volunteer.appliedFor": "Đã đăng ký cho",
    "volunteer.verificationComplete": "Xác minh hoàn tất",
    "volunteer.hoursVerified":
      "Giờ tình nguyện đã được xác minh và ghi nhận trên blockchain.",
    "volunteer.verificationHash": "Mã băm xác minh",
    "volunteer.applicationAccepted": "Đơn đăng ký đã được chấp nhận",
    "volunteer.applicationRecorded":
      "Đơn đăng ký tình nguyện đã được chấp nhận và ghi nhận trên blockchain.",
    "volunteer.acceptanceHash": "Mã băm chấp nhận",
    "volunteer.pendingHours": "Giờ tình nguyện chờ duyệt",
    "volunteer.noPendingHours": "Không có giờ tình nguyện chờ xác minh.",
    "volunteer.pendingApplications": "Đơn đăng ký chờ duyệt",
    "volunteer.noPendingApplications": "Không có đơn đăng ký chờ xem xét.",
    "volunteer.createOpportunity": "Tạo cơ hội tình nguyện",
    "volunteer.createNew": "Tạo mới",
    "volunteer.noOpportunitiesYet":
      'Chưa có cơ hội nào được tạo. Nhấn "Tạo mới" để bắt đầu.',
    "volunteer.opportunityTitle": "Tên cơ hội",
    "volunteer.skills": "Kỹ năng (phân cách bằng dấu phẩy)",
    "volunteer.commitment": "Cam kết",
    "volunteer.location": "Địa điểm",
    "volunteer.type": "Loại",
    "volunteer.workLanguage": "Ngôn ngữ làm việc",
    "volunteer.status": "Trạng thái",

    // Volunteer commitment types
    "volunteer.commitment.oneTime": "Một lần",
    "volunteer.commitment.shortTerm": "Ngắn hạn",
    "volunteer.commitment.longTerm": "Dài hạn",

    // Volunteer types
    "volunteer.type.remote": "Từ xa",
    "volunteer.type.onsite": "Tại chỗ",
    "volunteer.type.hybrid": "Kết hợp",
    "volunteer.type.onSite": "Tại chỗ",

    // Volunteer - Opportunities page
    "volunteer.workTypeFilter": "Bộ lọc loại công việc",
    "volunteer.searchLocation": "Thành phố hoặc khu vực...",
    "volunteer.searchLocationAria": "Tìm kiếm địa điểm",
    "volunteer.filter.skill": "Kỹ năng: {{value}}",
    "volunteer.filter.type": "Loại: {{value}}",
    "volunteer.filter.language": "Ngôn ngữ: {{value}}",
    "volunteer.filter.location": "Địa điểm: {{value}}",
    "volunteer.loadingOpportunities": "Đang tải cơ hội...",
    "volunteer.loadOpportunitiesError": "Không thể tải các cơ hội tình nguyện. Vui lòng thử lại sau.",
    "volunteer.viewDetails": "Xem chi tiết",
    "volunteer.backToOpportunities": "Quay lại danh sách cơ hội",
    "volunteer.detail.about": "Về cơ hội này",
    "volunteer.detail.skills": "Kỹ năng cần thiết",
    "volunteer.detail.commitment": "Thời gian cam kết",
    "volunteer.detail.location": "Địa điểm",
    "volunteer.detail.language": "Ngôn ngữ",
    "volunteer.detail.hostedBy": "Tổ chức bởi",
    "volunteer.detail.ongoing": "Liên tục",
    "volunteer.detail.applicationsClosed": "Đã đóng đơn đăng ký",
    "volunteer.detail.notFoundTitle": "Không tìm thấy cơ hội",
    "volunteer.detail.notFoundMessage": "Cơ hội này có thể đã đủ người hoặc đã bị gỡ bỏ.",
    "volunteer.field.requirements": "Yêu cầu",
    "volunteer.field.benefits": "Quyền lợi",
    "volunteer.field.schedule": "Lịch trình",
    "volunteer.field.schedulePlaceholder": "vd: Thứ Ba 18-20 giờ, cuối tuần linh hoạt",
    "volunteer.field.startDate": "Ngày bắt đầu",
    "volunteer.field.endDate": "Ngày kết thúc",
    "volunteer.field.endDateHelp": "Để trống nếu liên tục",
    "volunteer.field.applicationDeadline": "Hạn nộp đơn",
    "volunteer.field.volunteersNeeded": "Số tình nguyện viên cần",
    "volunteer.field.minimumAge": "Độ tuổi tối thiểu",
    "volunteer.field.backgroundCheckRequired": "Yêu cầu kiểm tra lý lịch",
    "volunteer.field.trainingProvided": "Có đào tạo",
    "volunteer.field.onePerLine": "mỗi dòng một mục",
    "volunteer.validation.volunteersNeeded": "Nhập số từ 1 trở lên",
    "volunteer.validation.minimumAge": "Nhập độ tuổi từ 0 đến 120",
    "volunteer.validation.endDate": "Ngày kết thúc phải cùng hoặc sau ngày bắt đầu",
    "volunteer.signInToApply":
      "Vui lòng đăng nhập để đăng ký cơ hội tình nguyện",
    "volunteer.applicationSuccess": "Đơn đăng ký đã được gửi thành công!",
    "volunteer.removeFilter": "Xóa bộ lọc {{filter}}",

    // Volunteer - OpportunityForm
    "volunteer.validation.titleRequired": "Tiêu đề là bắt buộc",
    "volunteer.validation.descriptionRequired": "Mô tả là bắt buộc",
    "volunteer.validation.skillsRequired": "Cần ít nhất một kỹ năng",
    "volunteer.validation.locationRequired": "Địa điểm là bắt buộc",
    "volunteer.profileNotFound": "Không tìm thấy hồ sơ người dùng",
    "volunteer.correctErrors": "Vui lòng sửa các lỗi xác thực",
    "volunteer.createFailed": "Tạo cơ hội thất bại",
    "volunteer.descriptionPlaceholder": "Mô tả chi tiết cơ hội tình nguyện...",
    "volunteer.skillsPlaceholder":
      "ví dụ: Phát triển web, Quản lý dự án, Dịch thuật",
    "volunteer.locationPlaceholder": "ví dụ: Từ xa, Hà Nội, TP. Hồ Chí Minh",
    "volunteer.headerImage": "Ảnh tiêu đề",
    "volunteer.headerImageHelp":
      "Tải lên hình ảnh để hiển thị ở đầu danh sách cơ hội",
    "volunteer.limitReached": "Đã đạt giới hạn cơ hội",
    "volunteer.limitReachedMessage":
      "Bạn đã đạt tối đa {{max}} cơ hội tình nguyện đang hoạt động. Vui lòng đóng hoặc hoàn thành một cơ hội hiện có trước khi tạo mới.",
    "volunteer.opportunityCount":
      "Bạn có {{count}} trong số {{max}} cơ hội đang hoạt động.",

    // Volunteer - HoursVerificationTab
    "volunteer.hoursVerification": "Xác minh giờ",
    "volunteer.hoursVerificationDescription":
      "Xem xét và xác minh các yêu cầu giờ tình nguyện",
    "volunteer.formalHours": "Giờ đã ghi nhận",
    "volunteer.selfReported": "Tự khai báo",
    "volunteer.loggedHours": "Giờ tình nguyện đã ghi nhận",
    "volunteer.loggedHoursDescription":
      "Giờ được ghi nhận bởi tình nguyện viên thông qua các cơ hội của bạn",
    "volunteer.allCaughtUp": "Đã cập nhật hết!",
    "volunteer.noPendingLoggedHours": "Không có giờ ghi nhận chờ xác minh.",
    "volunteer.selfReportedHours": "Giờ tự khai báo",

    // Volunteer - OpportunitiesTab
    "volunteer.noOpportunitiesTitle": "Chưa có cơ hội nào",
    "volunteer.activeCount": "{{count}} trong số {{max}} cơ hội đang hoạt động",
    "volunteer.moreSkills": "+{{count}} thêm",

    // Volunteer - ApplicationsTab
    "volunteer.noApplications": "Không có đơn đăng ký chờ duyệt",
    "volunteer.unknownOpportunity": "Cơ hội không xác định",

    // Volunteer - VerificationLookup
    "volunteer.verifyContribution": "Xác minh đóng góp tình nguyện",
    "volunteer.hashPlaceholder": "Nhập mã băm xác minh",
    "volunteer.searching": "Đang tìm kiếm...",
    "volunteer.verifyHash": "Xác minh mã băm",
    "volunteer.verificationNotFound": "Không tìm thấy xác minh",
    "volunteer.verificationNotFoundMessage":
      "Không tìm thấy mã băm bạn cung cấp trong hệ thống. Vui lòng kiểm tra mã băm và thử lại.",
    "volunteer.unknownOrganization": "Tổ chức không xác định",

    // Volunteer - VolunteerVerificationCard
    "volunteer.contributionVerification": "Xác minh đóng góp tình nguyện",
    "volunteer.volunteerLabel": "Tình nguyện viên",
    "volunteer.opportunityLabel": "Cơ hội",
    "volunteer.organizationLabel": "Tổ chức",
    "volunteer.acceptedOn": "Được chấp nhận vào",
    "volunteer.verifiedOn": "Được xác minh vào",
    "volunteer.verificationHashes": "Mã băm xác minh",
    "volunteer.blockchainReference": "Tham chiếu blockchain",

    // Volunteer - VerifyContribution page
    "volunteer.verifyingContribution": "Đang xác minh đóng góp\u2026",
    "volunteer.noHashProvided": "Không có mã băm xác minh được cung cấp.",
    "volunteer.verificationSuccessful": "Xác minh thành công",
    "volunteer.contributionVerifiedBlockchain":
      "Đóng góp tình nguyện này đã được xác minh và ghi nhận trên blockchain.",
    "volunteer.verificationFailed": "Xác minh thất bại",
    "volunteer.hashNotFound":
      "Không tìm thấy hoặc mã băm xác minh {{hash}} không hợp lệ.",

    // Volunteer - SelfReportedHoursDashboard
    "volunteer.volunteerHoursTitle": "Giờ tình nguyện",
    "volunteer.aboutSelfReported": "Về giờ tự khai báo",
    "volunteer.selfReportedInfo":
      "Chỉ những giờ được xác nhận bởi các tổ chức đã xác minh mới được tính vào Bảng xếp hạng Tác động Toàn cầu. Giờ cho các tổ chức không có trên nền tảng có thể được theo dõi nhưng sẽ được đánh dấu là \u201cChưa xác nhận\u201d cho đến khi nhận được xác nhận.",
    "volunteer.logHoursButton": "Ghi nhận giờ",
    "volunteer.logVolunteerHours": "Ghi nhận giờ tình nguyện",
    "volunteer.editRecord": "Chỉnh sửa bản ghi",
    "volunteer.recordDetails": "Chi tiết bản ghi",
    "volunteer.backToList": "Quay lại danh sách",
    "volunteer.deleteRecord": "Xóa bản ghi?",
    "volunteer.deleteConfirmation":
      "Bạn có chắc chắn muốn xóa bản ghi giờ tình nguyện này? Hành động này không thể hoàn tác.",

    // Volunteer - SelfReportedHoursForm
    "volunteer.activityType": "Loại hoạt động",
    "volunteer.organization": "Tổ chức",
    "volunteer.searchRegistry": "Tìm trong danh bạ",
    "volunteer.searchRegistryPlaceholder":
      "Tìm trong sổ đăng ký tổ chức từ thiện theo tên hoặc mã số thuế…",
    "volunteer.registryTaxId": "Mã số thuế {{value}}",
    "volunteer.notListed": "Không có trong danh sách",
    "volunteer.organizationName": "Tên tổ chức",
    "volunteer.enterOrgName": "Nhập tên tổ chức",
    "volunteer.contactEmail": "Email liên hệ",
    "volunteer.contactEmailOptional": "(không bắt buộc)",
    "volunteer.onboardHelp":
      "Chúng tôi có thể liên hệ để giúp đưa tổ chức này lên nền tảng",
    "volunteer.submittedForValidation": "Bản ghi này sẽ được gửi để xác nhận",
    "volunteer.submittedForValidationTo":
      "Bản ghi này sẽ được gửi để xác nhận tới {{org}}",
    "volunteer.validationExpired": "Thời hạn xác nhận đã hết cho ngày này",
    "volunteer.savedAsUnvalidated": "Bản ghi này sẽ được lưu là chưa xác nhận",
    "volunteer.describeActivities": "Mô tả các hoạt động bạn đã thực hiện...",
    "volunteer.moreCharsNeeded": "Cần thêm {{count}} ký tự",
    "volunteer.updating": "Đang cập nhật...",
    "volunteer.logging": "Đang ghi nhận...",
    "volunteer.updateHours": "Cập nhật giờ",

    // Volunteer - SelfReportedHoursList
    "volunteer.statusFilter": "Trạng thái",
    "volunteer.activityTypeFilter": "Loại hoạt động",
    "volunteer.filterFrom": "Từ",
    "volunteer.filterTo": "Đến",
    "volunteer.clearFilters": "Xóa bộ lọc",
    "volunteer.allStatuses": "Tất cả",
    "volunteer.allActivityTypes": "Tất cả loại",
    "volunteer.noMatchingRecords": "Không có bản ghi phù hợp",
    "volunteer.noHoursLogged": "Chưa có giờ tình nguyện nào được ghi nhận",
    "volunteer.adjustFilters": "Thử điều chỉnh bộ lọc để tìm bản ghi.",
    "volunteer.startLogging":
      "Bắt đầu bằng cách ghi nhận giờ tình nguyện đầu tiên của bạn.",

    // Volunteer - SelfReportedHoursStats
    "volunteer.validatedHours": "Giờ đã xác nhận",
    "volunteer.pendingValidation": "Chờ xác nhận",
    "volunteer.unvalidatedHours": "Giờ chưa xác nhận",
    "volunteer.rejectedLabel": "Bị từ chối",
    "volunteer.hoursUnit": "giờ",
    "volunteer.recordSingular": "bản ghi",
    "volunteer.recordPlural": "bản ghi",

    // Volunteer - VolunteerApplicationForm
    "volunteer.applicationTitle": "Đơn đăng ký cơ hội tình nguyện",
    "volunteer.applicationSubtitle":
      "Giúp tạo tác động bền vững thông qua các đóng góp được xác minh",
    "volunteer.progress.info": "Thông tin",
    "volunteer.progress.skills": "Kỹ năng",
    "volunteer.progress.consent": "Đồng ý",
    "volunteer.fieldValid": "Trông ổn",
    "volunteer.draftSaved": "Đã lưu bản nháp",
    "volunteer.personalInfo": "Thông tin cá nhân",
    "volunteer.firstName": "Họ",
    "volunteer.lastName": "Tên",
    "volunteer.emailAddress": "Địa chỉ email",
    "volunteer.phoneNumber": "Số điện thoại",
    "volunteer.locationCity": "Địa điểm/Thành phố",
    "volunteer.locationCityPlaceholder": "ví dụ: Hà Nội, Việt Nam",
    "volunteer.timeZone": "Múi giờ",
    "volunteer.selectTimeZone": "Chọn múi giờ",
    "volunteer.ageRange": "Độ tuổi",
    "volunteer.selectAgeRange": "Chọn độ tuổi",
    "volunteer.skillsAndInterests": "Kỹ năng & Sở thích",
    "volunteer.skillsLabel": "Kỹ năng và lĩnh vực quan tâm",
    "volunteer.skillPlaceholderFull":
      "Bắt đầu nhập kỹ năng của bạn (ví dụ: Lập trình Python, Thuyết trình, Viết đề xuất tài trợ)",
    "volunteer.skillPlaceholderShort": "Nhập kỹ năng và nhấn Enter...",
    "volunteer.commitmentLevel": "Mức độ cam kết",
    "volunteer.commitmentOneTimeDesc": "Dự án đơn lẻ hoặc nhiệm vụ ngắn hạn",
    "volunteer.commitmentShortTermDesc": "Vài tuần đến vài tháng",
    "volunteer.commitmentLongTermDesc": "Cam kết liên tục nhiều tháng trở lên",
    "volunteer.experienceLabel": "Chia sẻ về kinh nghiệm liên quan của bạn",
    "volunteer.experiencePlaceholder":
      "Mô tả nền tảng, kỹ năng và động lực tình nguyện với Give Protocol của bạn...",
    "volunteer.consentTitle": "Đồng ý & Thỏa thuận",
    "volunteer.consentHeader": "Đồng ý đơn đăng ký tình nguyện",
    "volunteer.submitting": "Đang gửi...",
    "volunteer.submitApplication": "Gửi đơn đăng ký tình nguyện",
    "volunteer.disclaimerText":
      "Bằng việc gửi đơn đăng ký này, bạn xác nhận đã đọc và hiểu chính sách bảo mật và hướng dẫn tình nguyện của Give Protocol. Dữ liệu của bạn sẽ được xử lý theo các quy định bảo vệ dữ liệu hiện hành.",
    "volunteer.validation.firstNameInvalid": "Vui lòng nhập họ hợp lệ",
    "volunteer.validation.lastNameInvalid": "Vui lòng nhập tên hợp lệ",
    "volunteer.validation.emailInvalid": "Vui lòng nhập địa chỉ email hợp lệ",
    "volunteer.validation.phoneInvalid": "Vui lòng nhập số điện thoại hợp lệ",
    "volunteer.validation.experienceRequired":
      "Vui lòng mô tả kinh nghiệm liên quan của bạn",
    "volunteer.validation.addSkill": "Vui lòng thêm ít nhất một kỹ năng",
    "volunteer.validation.ageRangeRequired": "Vui lòng chọn độ tuổi của bạn",
    "volunteer.validation.consentRequired":
      "Bạn phải đồng ý với tất cả các mục đồng ý bắt buộc",
    "volunteer.signInToSubmit": "Vui lòng đăng nhập để gửi đơn đăng ký",
    "volunteer.submitFailed": "Gửi đơn đăng ký thất bại. Vui lòng thử lại.",

    // Volunteer - ApplicationForm
    "volunteer.applyForTitle": "Đăng ký cho: {{title}}",
    "volunteer.fullName": "Họ và tên *",
    "volunteer.phoneRequired": "Số điện thoại *",
    "volunteer.emailRequired": "Địa chỉ email *",
    "volunteer.dateOfBirth": "Ngày sinh",
    "volunteer.availabilityTitle": "Khả năng tham gia",
    "volunteer.preferredDays": "Ngày ưu tiên",
    "volunteer.preferredTimes": "Thời gian ưu tiên",
    "volunteer.commitmentLevelLabel": "Mức độ cam kết",
    "volunteer.skillsAndExperience": "Kỹ năng & Kinh nghiệm",
    "volunteer.relevantExperience": "Kinh nghiệm liên quan *",
    "volunteer.certifications": "Chứng chỉ (phân cách bằng dấu phẩy)",
    "volunteer.interestsAndPreferences": "Sở thích & Ưu tiên",
    "volunteer.areasOfInterest": "Lĩnh vực quan tâm (phân cách bằng dấu phẩy)",
    "volunteer.referencesTitle": "Người tham chiếu",
    "volunteer.referenceName": "Tên người tham chiếu {{index}}",
    "volunteer.referenceContact": "Liên hệ người tham chiếu {{index}}",
    "volunteer.workSamplesTitle": "Mẫu công việc",
    "volunteer.workSamplesLabel":
      "Liên kết đến mẫu công việc (phân cách bằng dấu phẩy)",
    "volunteer.submitApplicationShort": "Gửi đơn đăng ký",
    "volunteer.validation.nameInvalid":
      "Vui lòng nhập tên hợp lệ (2-100 ký tự)",
    "volunteer.validation.provideExperience":
      "Vui lòng cung cấp thông tin về kinh nghiệm của bạn",
    "volunteer.validation.selectDay": "Vui lòng chọn ít nhất một ngày",
    "volunteer.validation.selectTime": "Vui lòng chọn ít nhất một khung giờ",

    // Volunteer - ConsentForm
    "volunteer.consentUnderstand": "Tôi hiểu rằng:",
    "volunteer.processingAckTitle": "XÁC NHẬN XỬ LÝ",
    "volunteer.processingAckDesc":
      "Vui lòng xem xét và xác nhận những điều sau trước khi tiếp tục:",
    "volunteer.essentialProcessingTitle":
      "Xử lý Đơn đăng ký (Bắt buộc xác nhận):",
    "volunteer.acknowledgmentTitle": "XÁC NHẬN",
    "volunteer.ageConfirmationTitle": "Xác nhận độ tuổi:",
    "volunteer.privacyNoticeTitle": "Thông báo bảo mật:",
    "volunteer.doNotAccept": "Không đồng ý",
    "volunteer.acceptAndContinue": "Đồng ý và tiếp tục",
    "volunteer.validation.essentialRequired":
      "Bạn phải xác nhận việc xử lý đơn đăng ký để tiếp tục",
    "volunteer.validation.agePrivacyRequired":
      "Bạn phải xác nhận độ tuổi và rằng bạn đã đọc Thông báo bảo mật",

    // Age affirmation gate (shared across all surfaces — GIV-453)
    "ageGate.positive": "Tôi xác nhận rằng tôi từ 16 tuổi trở lên.",
    "ageGate.negative":
      "Give Protocol dành cho người dùng từ 16 tuổi trở lên. Nếu bạn dưới 16 tuổi, chúng tôi không thể xử lý yêu cầu của bạn vào lúc này.",

    // Languages
    "language.english": "Tiếng Anh",
    "language.spanish": "Tiếng Tây Ban Nha",
    "language.german": "Tiếng Đức",
    "language.french": "Tiếng Pháp",
    "language.japanese": "Tiếng Nhật",
    "language.chinese_simplified": "Tiếng Trung (Giản thể)",
    "language.chinese_traditional": "Tiếng Trung (Phồn thể)",
    "language.thai": "Tiếng Thái",
    "language.vietnamese": "Tiếng Việt",
    "language.korean": "Tiếng Hàn",
    "language.arabic": "Tiếng Ả Rập",
    "language.hindi": "Tiếng Hindi",
    "language.multiple": "Nhiều ngôn ngữ",

    // Contribution types
    "contribution.type.donation": "Quyên góp",
    "contribution.type.volunteerapplication": "Đơn đăng ký tình nguyện",
    "contribution.type.volunteerhours": "Giờ tình nguyện",
    "contribution.type.volunteeracceptance": "Chấp nhận tình nguyện",
    "contribution.type.volunteerverification": "Xác minh tình nguyện",

    // Donor/Volunteer
    "donor.volunteer": "Nhà tài trợ/Tình nguyện viên",
    "donor.anonymous": "Ẩn danh",
    "volunteer.unknown": "Tình nguyện viên không xác định",

    // Statuses
    "status.completed": "Hoàn thành",
    "status.pending": "Đang chờ",
    "status.failed": "Thất bại",

    // Blockchain
    "blockchain.block": "Khối",

    // Filter
    "filter.allYears": "Tất cả các năm",
    "filter.allTypes": "Tất cả loại",
    "filter.donations": "Quyên góp",
    "filter.volunteerApplications": "Đơn đăng ký tình nguyện",
    "filter.volunteerHours": "Giờ tình nguyện",
    "filter.fiatDonations": "Quyên góp tiền mặt",

    // Export
    "export.title": "Xuất dữ liệu đóng góp",
    "export.filename": "Tên tệp",
    "export.dateRange": "Phạm vi ngày",
    "export.includePersonal": "Bao gồm địa chỉ ví",
    "export.willInclude": "Bản xuất sẽ bao gồm:",
    "export.walletAddresses": "Địa chỉ ví (người gửi và người nhận)",
    "export.volunteerDetails": "Chi tiết đóng góp tình nguyện (khi áp dụng)",
    "export.verificationHashes": "Mã băm xác minh (khi áp dụng)",
    "export.cancel": "Hủy",
    "export.download": "Xuất CSV",

    // Skills
    "skills.endorsements": "Kỹ năng & Xác nhận",

    // Home
    "home.subtitle": "Kết nối nguồn lực đến những mục đích cần chúng nhất",
    "home.startDonating": "Bắt đầu quyên góp",

    // Modal - shared
    "modal.close": "Đóng hộp thoại",
    "modal.closeAriaLabel": "Đóng",

    // Modal - wallet connection
    "modal.wallet.title": "Kết nối ví của bạn",
    "modal.wallet.description":
      "Kết nối ví để mở khóa tất cả tính năng của Give Protocol",
    "modal.wallet.benefit1": "Theo dõi quyên góp minh bạch trên blockchain",
    "modal.wallet.benefit2":
      "Nhận token GIVE như phần thưởng cho đóng góp của bạn",
    "modal.wallet.benefit3": "Tham gia các quyết định quản trị cho giao thức",
    "modal.wallet.connecting": "Đang kết nối...",
    "modal.wallet.clickToConnect": "Nhấn để kết nối",
    "modal.wallet.noExtension": "Không phát hiện tiện ích mở rộng ví.",
    "modal.wallet.installMetaMask": "Cài đặt MetaMask để bắt đầu",
    "modal.wallet.skip": "Bỏ qua",
    "modal.wallet.footerNote":
      "Bạn có thể kết nối ví bất cứ lúc nào từ thanh điều hướng",
    "modal.wallet.failedConnect": "Kết nối ví thất bại",

    // Modal - wallet link
    "modal.walletLink.title": "Liên kết ví của bạn",
    "modal.walletLink.description":
      "Liên kết ví với tài khoản của bạn để quyên góp on-chain, nhận token thưởng và quản trị",
    "modal.walletLink.benefit1":
      "Quyên góp tiền mã hóa trực tiếp cho các tổ chức từ thiện đã xác minh trên chain",
    "modal.walletLink.benefit2Pre": "Phát triển",
    "modal.walletLink.benefit2Post": "thông tin xác thực cho đóng góp của bạn",
    "modal.walletLink.benefit3":
      "Đăng nhập bằng email hoặc ví \u2014 cùng một tài khoản",
    "modal.walletLink.buttonLinking": "Đang liên kết\u2026",
    "modal.walletLink.buttonLink": "Liên kết ví",
    "modal.walletLink.buttonConnectFirst": "Kết nối ví trước",
    "modal.walletLink.footerNote":
      "Bạn có thể liên kết ví bất cứ lúc nào từ Cài đặt",
    "modal.walletLink.failedLink": "Liên kết ví thất bại",

    // Modal - chain selection
    "modal.chain.title": "Chào mừng đến với Give Protocol",
    "modal.chain.subtitle": "Chọn mạng ưu tiên của bạn để bắt đầu",
    "modal.chain.footerNote": "Bạn có thể chuyển mạng bất cứ lúc nào từ menu",
    "modal.chain.connecting": "Đang kết nối...",
    "modal.chain.continue": "Tiếp tục",
    "modal.chain.failedSelect": "Chọn mạng thất bại",

    // Modal - network selection (WalletModal step 1)
    "modal.network.title": "Chọn mạng",
    "modal.network.nextStep": "Bước tiếp theo: Kết nối ví",
    "modal.network.learnMore": "Tìm hiểu thêm về lựa chọn mạng",

    // Modal - wallet connect (WalletModal step 2)
    "modal.connect.title": "Kết nối ví",
    "modal.connect.backAria": "Quay lại chọn mạng",
    "modal.connect.noWallets": "Không có ví khả dụng cho chuỗi {{chainType}}.",
    "modal.connect.tryDifferentChain": "Thử chọn một loại chuỗi khác.",
    "modal.connect.viewOtherWallets": "Xem các ví được hỗ trợ khác",
    "modal.connect.termsAgreement": "Bằng việc kết nối, bạn đồng ý với",
    "modal.connect.termsLink": "Điều khoản dịch vụ",
    "modal.connect.termsPrivacyConnector": "và",
    "modal.connect.privacyLink": "Chính sách Bảo mật",
    "modal.connect.chainTypeAria": "Loại chuỗi",
    "modal.connect.failedConnect": "Kết nối thất bại",

    // Modal - donation
    "modal.donation.successTitle": "Cảm ơn bạn!",
    "modal.donation.donationProcessedOneTime":
      "Khoản quyên góp {{amount}} của bạn cho {{charityName}} đã được xử lý.",
    "modal.donation.donationProcessedRecurring":
      "Khoản quyên góp hàng tháng {{amount}} của bạn cho {{charityName}} đã được xử lý.",
    "modal.donation.recurringNote":
      "Bạn sẽ bị tính phí hàng tháng cho đến khi hủy.",
    "modal.donation.receiptNote": "Biên lai đã được gửi đến email của bạn.",
    "modal.donation.done": "Xong",
    "modal.donation.errorTitle": "Đã xảy ra lỗi",
    "modal.donation.errorDefault":
      "Đã xảy ra lỗi không mong muốn. Vui lòng thử lại.",
    "modal.donation.tryAgain": "Thử lại",
    "modal.donation.close": "Đóng",
    "modal.donation.amountLabel": "Số tiền quyên góp",
    "modal.donation.perMonth": "mỗi tháng",
    "modal.donation.monthly": "Hàng tháng",
    "modal.donation.oneTime": "Một lần",
    "modal.donation.loadingPaymentForm": "Đang tải biểu mẫu thanh toán...",
    "modal.donation.supportMonthly": "Hỗ trợ {{charityName}} hàng tháng",
    "modal.donation.donateToCharity": "Quyên góp cho {{charityName}}",

    // Modal - scheduled donation
    "modal.scheduledDonation.title":
      "Lên lịch quyên góp hàng tháng cho {{charityName}}",

    // Modal - withdrawal
    "modal.withdrawal.title": "Yêu cầu rút tiền",

    // Modal - validation response
    "modal.validation.rejectTitle": "Từ chối yêu cầu xác nhận",
    "modal.validation.reviewTitle": "Xem xét yêu cầu xác nhận",
    "modal.validation.volunteer": "Tình nguyện viên",
    "modal.validation.activityDetails": "Chi tiết hoạt động",
    "modal.validation.date": "Ngày",
    "modal.validation.hour": "giờ",
    "modal.validation.hours": "giờ",
    "modal.validation.activityType": "Loại hoạt động",
    "modal.validation.location": "Địa điểm",
    "modal.validation.description": "Mô tả",
    "modal.validation.submitted": "Đã gửi:",
    "modal.validation.daysRemaining": "(còn {{count}} ngày để xác nhận)",
    "modal.validation.appealNote":
      "Đây là đơn kháng cáo/gửi lại của yêu cầu đã bị từ chối trước đó",
    "modal.validation.rejectPrompt":
      "Vui lòng chọn lý do từ chối yêu cầu xác nhận này. Tình nguyện viên sẽ được thông báo.",
    "modal.validation.reject": "Từ chối",
    "modal.validation.approve": "Phê duyệt",
    "modal.validation.processing": "Đang xử lý...",
    "modal.validation.back": "Quay lại",
    "modal.validation.confirmRejection": "Xác nhận từ chối",
    "modal.validation.selectReasonError": "Vui lòng chọn lý do từ chối",

    // Toast
    "toast.dismiss": "Bỏ qua thông báo",

    // Error boundary
    "error.somethingWrong": "Đã xảy ra lỗi",
    "error.unexpectedError": "Đã xảy ra lỗi không mong muốn",
    "error.tryAgain": "Thử lại",
    "error.tooManyAttempts": "Quá nhiều lần thử",
    "error.goHome": "Về trang chủ",
    "error.details": "Chi tiết lỗi",

    // Validation - rejection reason select
    "validation.rejection.reasonLabel": "Lý do từ chối",
    "validation.rejection.reasonPlaceholder": "Chọn lý do...",
    "validation.rejection.notesLabel": "Ghi chú bổ sung",
    "validation.rejection.optional": "(không bắt buộc)",
    "validation.rejection.notesPlaceholder":
      "Cung cấp thêm ngữ cảnh cho việc từ chối...",

    // Validation - batch actions
    "validation.batch.deselectAll": "Bỏ chọn tất cả",
    "validation.batch.selectAll": "Chọn tất cả",
    "validation.batch.selected": "{{selected}} trong số {{total}} đã chọn",
    "validation.batch.clear": "Xóa",
    "validation.batch.reject": "Từ chối ({{count}})",
    "validation.batch.approve": "Phê duyệt ({{count}})",

    // Dashboard - admin redirect (GIV-254)
    "dashboard.adminTitle": "Bảng điều khiển quản trị",
    "dashboard.adminNote":
      "Vui lòng sử dụng bảng quản trị để quản lý nền tảng.",
    "dashboard.adminButton": "Đi đến bảng quản trị",
    "dashboard.logVolunteerHours": "Ghi nhận giờ tình nguyện",
    "dashboard.hideVolunteerHours": "Ẩn giờ tình nguyện",
    "dashboard.viewMonthlyDonations": "Xem quyên góp hàng tháng",
    "dashboard.hideMonthlyDonations": "Ẩn quyên góp hàng tháng",
    "dashboard.walletSettings": "Cài đặt ví",
    "dashboard.overview": "Tổng quan",
    "dashboard.lastUpdated": "Cập nhật lần cuối",
    "dashboard.refreshData": "Làm mới dữ liệu",
    "dashboard.searchPlaceholder": "Tìm kiếm dự án, tình nguyện viên (Cmd+K)",
    "dashboard.search": "Tìm kiếm",

    // Settings - account section (GIV-254)
    "settings.manageDescription": "Quản lý tài khoản và tùy chọn của bạn",
    "settings.account": "Tài khoản",
    "settings.email": "Email",
    "settings.displayName": "Tên hiển thị",
    "settings.authMethod": "Phương thức xác thực",
    "settings.role": "Vai trò",

    // Common additional (GIV-254)
    "common.refresh": "Làm mới",
    "common.all": "Tất cả",
    "common.loading": "Đang tải...",
    "common.close": "Đóng",
    "common.back": "Quay lại",

    // Cause (GIV-254)
    "cause.createCause": "Tạo mục đích",

    // Contribution Tracker (GIV-254)
    "tracker.title": "Bảng xếp hạng tác động toàn cầu",
    "tracker.subtitle":
      "Theo dõi và tôn vinh tác động tập thể của cộng đồng chúng ta",
    "tracker.searchPlaceholder": "Tìm kiếm người đóng góp...",
    "tracker.exportCSV": "Xuất CSV",
    "tracker.exportPDF": "Xuất PDF",
    "tracker.hideContributions": "Ẩn đóng góp của tôi khỏi bảng xếp hạng",
    "tracker.yourAlias": "Bí danh của bạn:",
    "tracker.changeAlias": "Thay đổi",
    "tracker.setWalletAlias": "Đặt bí danh ví",
    "tracker.aliasTitle": "Đặt bí danh ví",
    "tracker.aliasDescription":
      "Bí danh của bạn sẽ được hiển thị trên bảng theo dõi đóng góp thay vì địa chỉ ví.",
    "tracker.aliasLabel": "Bí danh",
    "tracker.aliasPlaceholder": "Nhập bí danh ưu thích của bạn",
    "tracker.saveAlias": "Lưu bí danh",
    "tracker.donationRankings": "Bảng xếp hạng quyên góp",
    "tracker.volunteerRankings": "Bảng xếp hạng tình nguyện",
    "tracker.exportComplete": "Xuất hoàn tất",
    "tracker.exportDonationCSV":
      "Bảng xếp hạng quyên góp đã được xuất dạng CSV",
    "tracker.exportVolunteerCSV":
      "Bảng xếp hạng tình nguyện đã được xuất dạng CSV",
    "tracker.exportPDFSuccess": "Bảng xếp hạng đã được xuất dạng PDF",
    "tracker.exportFailed": "Xuất thất bại",
    "tracker.exportNoData": "Không có dữ liệu để xuất",
    "tracker.exportError": "Đã xảy ra lỗi khi xuất dữ liệu",
    "tracker.walletNotConnected": "Ví chưa được kết nối",
    "tracker.connectWalletForAlias": "Vui lòng kết nối ví để đặt bí danh",
    "tracker.invalidAlias": "Bí danh không hợp lệ",
    "tracker.enterValidAlias": "Vui lòng nhập bí danh hợp lệ",

    // Charity Portal (GIV-254)
    "charity.portal.deleteTitle": "Xóa {{type}}?",
    "charity.portal.deleteDescription":
      "Hành động này không thể hoàn tác. {{type}} sẽ bị xóa vĩnh viễn.",
    "charity.portal.walletNotConfigured": "Ví nhận chưa được cấu hình.",
    "charity.portal.walletDonationNote":
      "Kết nối ví để nhận quyên góp on-chain.",
    "charity.portal.setupWallet": "Thiết lập ví",

    // Charity dashboard onboarding & verification
    "charity.onboarding.ariaLabel": "Danh sách kiểm tra bắt đầu",
    "charity.onboarding.title": "Bắt đầu",
    "charity.onboarding.progress": "Đã hoàn thành {{completed}}/{{total}} bước",
    "charity.onboarding.optional": "Tùy chọn",
    "charity.onboarding.allComplete":
      "Đã hoàn thành tất cả các bước! Bạn có thể đóng danh sách này.",
    "charity.onboarding.expand": "Mở rộng danh sách",
    "charity.onboarding.collapse": "Thu gọn danh sách",
    "charity.onboarding.dismiss": "Đóng danh sách kiểm tra bắt đầu",
    "charity.onboarding.check": "Đánh dấu {{label}}",
    "charity.onboarding.uncheck": "Bỏ đánh dấu {{label}}",
    "charity.onboarding.stepDone": "{{label}} (đã hoàn thành)",
    "charity.onboarding.stepAuto": "{{label}} (tự động hoàn thành)",
    "charity.onboarding.goToOrganization": "Đến trang Tổ chức",
    "charity.onboarding.setupWallet": "Thiết lập ví",
    "charity.onboarding.item.completeProfile.label": "Hoàn thiện hồ sơ tổ chức",
    "charity.onboarding.item.completeProfile.description":
      "Thêm tên, mô tả, địa chỉ và thông tin liên hệ của tổ chức.",
    "charity.onboarding.item.uploadLogo.label":
      "Tải lên logo hoặc ảnh biểu ngữ",
    "charity.onboarding.item.uploadLogo.description":
      "Thêm logo hoặc biểu ngữ để giúp nhà tài trợ nhận ra tổ chức từ thiện của bạn.",
    "charity.onboarding.item.connectWallet.label":
      "Thiết lập ví nhận quyên góp",
    "charity.onboarding.item.connectWallet.description":
      "Chọn Safe đa chữ ký, dịch vụ lưu ký tổ chức hoặc ví một chữ ký để nhận quyên góp. Chứng minh quyền kiểm soát bằng cách ký một thông điệp.",
    "charity.onboarding.item.bankDetails.label":
      "Thiết lập thông tin ngân hàng để quy đổi sang tiền pháp định",
    "charity.onboarding.item.bankDetails.description":
      "Cấu hình thông tin ngân hàng nếu bạn muốn nhận quyên góp qua thẻ.",
    "charity.onboarding.item.acceptTerms.label":
      "Xem và chấp nhận điều khoản dịch vụ",
    "charity.onboarding.item.acceptTerms.description":
      "Đọc và xác nhận điều khoản và điều kiện của Give Protocol dành cho tổ chức từ thiện.",
    "charity.verification.pendingTitle": "Đơn đăng ký đang được xem xét",
    "charity.verification.pendingBody":
      "Đội ngũ của chúng tôi đang xem xét đơn đăng ký của tổ chức từ thiện của bạn. Việc này thường mất 3–5 ngày làm việc. Chúng tôi sẽ gửi email khi có quyết định.",
    "charity.verification.rejectedTitle": "Đơn đăng ký chưa được phê duyệt",
    "charity.verification.reason": "Lý do: {{notes}}",
    "charity.verification.rejectedDefault":
      "Đơn đăng ký của bạn chưa được phê duyệt vào lúc này.",
    "charity.verification.contactSupport": "Liên hệ hỗ trợ",
    "charity.verification.suspendedTitle": "Tài khoản bị tạm ngưng",
    "charity.verification.suspendedDefault":
      "Tài khoản tổ chức từ thiện của bạn đã bị tạm ngưng.",
    "charity.verification.appealSuspension": "Khiếu nại việc tạm ngưng",
    "charity.verification.verifiedTitle": "Tổ chức từ thiện đã được xác minh",
    "charity.verification.verifiedBody":
      "Tổ chức của bạn đã được xác minh và các nhà tài trợ hiện có thể ủng hộ các hoạt động của bạn.",
    "charity.portal.receivingWallet": "Ví nhận quyên góp: {{address}}",
    "charity.portal.loadError":
      "Không thể tải dữ liệu tổ chức từ thiện. Vui lòng thử lại.",

    // Timestamps (GIV-254)
    "timestamp.justNow": "Vừa xong",
    "timestamp.oneMinuteAgo": "1 phút trước",
    "timestamp.minutesAgo": "{{count}} phút trước",

    // Common additions (GIV-256)
    "common.previous": "Trước",
    "common.next": "Tiếp",
    "common.pageOfTotal": "Trang {{page}} / {{total}}",
    "common.retry": "Thử lại",
    "common.processing": "Đang xử lý...",
    "common.saving": "Đang lưu...",
    "common.donate": "Quyên góp",
    "common.active": "Hoạt động",

    // Portfolio Funds - public page (GIV-256)
    "portfolio.donationType": "Loại quyên góp",
    "portfolio.devNative": "DEV (Gốc)",
    "portfolio.testToken": "TEST Token",
    "portfolio.donationAmount": "Số tiền quyên góp:",
    "portfolio.platformFee": "Phí nền tảng ({{percentage}}%):",
    "portfolio.toCharities": "Đến tổ chức từ thiện:",
    "portfolio.eachCharityReceives": "Mỗi tổ chức nhận:",
    "portfolio.donateToFund": "Quyên góp cho {{name}}",
    "portfolio.equalDistribution": "Phân phối đều",
    "portfolio.equalDistributionNote":
      "Khoản quyên góp của bạn sẽ được chia đều cho {{count}} tổ chức từ thiện đã xác minh.",
    "portfolio.eachCharityPercentage":
      "Mỗi tổ chức nhận {{percentage}}% quyên góp",
    "portfolio.verifiedCharities": "{{count}} tổ chức từ thiện đã xác minh",
    "portfolio.donateToFundButton": "Quyên góp cho quỹ",
    "portfolio.noFundsAvailable": "Không có quỹ danh mục khả dụng",
    "portfolio.checkBackLater": "Quay lại sau để xem cơ hội tài trợ mới",
    "portfolio.amountLabel": "Số tiền ({{currency}})",
    "portfolio.invalidAmount": "Vui lòng nhập số tiền hợp lệ",
    "portfolio.donationSuccess": "Quyên góp thành công!",
    "portfolio.donationFailed": "Quyên góp thất bại. Vui lòng thử lại.",

    // Admin - Activity event type labels (GIV-256)
    "admin.activity.donation": "Quyên góp",
    "admin.activity.registration": "Đăng ký",
    "admin.activity.verification": "Xác minh",
    "admin.activity.volunteerHours": "Giờ tình nguyện",
    "admin.activity.default": "Hoạt động",

    // Admin - Dashboard page (GIV-256)
    "admin.dashboard.title": "Bảng điều khiển quản trị",
    "admin.dashboard.alerts": "Cảnh báo",
    "admin.dashboard.alertsPending": "{{count}} đang chờ",
    "admin.dashboard.alertsView": "Xem",
    "admin.dashboard.recentActivity": "Hoạt động gần đây",
    "admin.dashboard.noRecentActivity": "Không có hoạt động gần đây.",
    "admin.dashboard.quickActions": "Thao tác nhanh",
    "admin.dashboard.errorTitle": "Lỗi tải bảng điều khiển",
    "admin.stats.last7d": "7 ngày qua",
    "admin.stats.last30d": "30 ngày qua",
    "admin.stats.totalDonors": "Tổng nhà tài trợ",
    "admin.stats.newRegistrations": "đăng ký mới",
    "admin.stats.charities": "Tổ chức từ thiện",
    "admin.stats.pendingVerification": "chờ xác minh",
    "admin.stats.verifiedCharities": "Tổ chức đã xác minh",
    "admin.stats.activeVolunteers": "Tình nguyện viên hoạt động",
    "admin.stats.totalDonationVolume": "Tổng khối lượng quyên góp",
    "admin.stats.cryptoVolume": "Khối lượng tiền mã hóa",
    "admin.stats.fiatVolume": "Khối lượng tiền pháp định",
    "admin.stats.donations": "quyên góp",

    // Admin - Quick Actions (GIV-256)
    "admin.actions.viewReports": "Xem báo cáo",
    "admin.actions.viewReportsDesc": "Tạo phân tích chi tiết",
    "admin.actions.manageCharities": "Quản lý tổ chức từ thiện",
    "admin.actions.manageCharitiesDesc": "Xem xét và phê duyệt tổ chức",
    "admin.actions.systemSettings": "Cài đặt hệ thống",
    "admin.actions.systemSettingsDesc": "Cấu hình các thông số nền tảng",
    "admin.actions.manageImpactMetrics": "Quản lý chỉ số tác động",
    "admin.actions.manageImpactMetricsDesc":
      "Cấu hình dữ liệu máy tính tác động",
    "admin.actions.donationMonitoring": "Giám sát quyên góp",
    "admin.actions.donationMonitoringDesc":
      "Giám sát, đánh dấu và báo cáo quyên góp",
    "admin.actions.contentModeration": "Kiểm duyệt nội dung",
    "admin.actions.contentModerationDesc":
      "Ẩn, đánh dấu và xem xét cơ hội và mục đích",
    "admin.actions.portfolioFunds": "Quỹ danh mục",
    "admin.actions.portfolioFundsDesc":
      "Tạo và quản lý danh mục quyên góp được tuyển chọn",
    "admin.actions.charityRequests": "Yêu cầu tổ chức từ thiện",
    "admin.actions.charityRequestsDesc":
      "Xem xét yêu cầu từ nhà tài trợ cho tổ chức chưa được nhận",

    // Admin - Portfolio Funds management page (GIV-256)
    "admin.portfolio.title": "Quỹ danh mục",
    "admin.portfolio.subtitle":
      "Tạo và quản lý danh mục quyên góp được tuyển chọn",
    "admin.portfolio.newFund": "Quỹ mới",
    "admin.portfolio.editFund": "Chỉnh sửa quỹ",
    "admin.portfolio.createNewFund": "Tạo quỹ mới",
    "admin.portfolio.fundName": "Tên quỹ",
    "admin.portfolio.fundNamePlaceholder": "ví dụ: Quỹ tác động môi trường",
    "admin.portfolio.description": "Mô tả",
    "admin.portfolio.descriptionPlaceholder":
      "Mô tả mục đích và trọng tâm tác động của quỹ...",
    "admin.portfolio.category": "Danh mục",
    "admin.portfolio.selectCategory": "Chọn danh mục",
    "admin.portfolio.imageUrl": "URL hình ảnh",
    "admin.portfolio.imageUrlPlaceholder": "https://...",
    "admin.portfolio.selectCharities":
      "Chọn tổ chức từ thiện (đã chọn {{count}})",
    "admin.portfolio.noCharitiesFound": "Không tìm thấy tổ chức đã xác minh",
    "admin.portfolio.saving": "Đang lưu...",
    "admin.portfolio.createFund": "Tạo quỹ",
    "admin.portfolio.updateFund": "Cập nhật quỹ",
    "admin.portfolio.noFundsYet": "Chưa có quỹ danh mục nào",
    "admin.portfolio.noFundsMessage":
      "Tạo quỹ đầu tiên để nhóm các tổ chức từ thiện cho quyên góp gộp",
    "admin.portfolio.charity": "tổ chức",
    "admin.portfolio.charities": "tổ chức",
    "admin.portfolio.createdOn": "Tạo ngày {{date}}",
    "admin.portfolio.statusActive": "hoạt động",
    "admin.portfolio.statusPaused": "tạm dừng",
    "admin.portfolio.statusArchived": "lưu trữ",
    "admin.portfolio.errorLoad": "Tải dữ liệu thất bại",
    "admin.portfolio.errorArchive": "Lưu trữ quỹ thất bại",
    "admin.portfolio.fundArchived": "Quỹ đã được lưu trữ",
    "admin.portfolio.fundUpdated": "Quỹ đã được cập nhật",
    "admin.portfolio.fundCreated": "Quỹ đã được tạo",
    "admin.portfolio.errorSave": "Lưu quỹ thất bại",

    // Admin - Charity Management page (GIV-256)
    "admin.charity.title": "Quản lý tổ chức từ thiện",
    "admin.charity.totalCount": "{{count}} tổng cộng",
    "admin.charity.allStatuses": "Tất cả trạng thái",
    "admin.charity.searchPlaceholder": "Tìm theo tên\u2026",
    "admin.charity.colName": "Tên",
    "admin.charity.colEin": "Mã số thuế",
    "admin.charity.taxIdDisplay": "Mã số thuế {{value}}",
    "admin.charity.searchByNameEin": "Tìm theo tên hoặc mã số thuế…",
    "admin.charity.colCategory": "Danh mục",
    "admin.charity.colStatus": "Trạng thái",
    "admin.charity.colSigner": "Liên hệ",
    "admin.charity.colJoined": "Ngày tham gia",
    "admin.charity.colWallet": "Ví",
    "admin.charity.colActions": "Thao tác",
    "admin.charity.walletNotSet": "Chưa thiết lập",
    "admin.charity.approve": "Phê duyệt",
    "admin.charity.reject": "Từ chối",
    "admin.charity.suspend": "Đình chỉ",
    "admin.charity.reinstate": "Khôi phục",
    "admin.charity.statusPending": "Đang chờ",
    "admin.charity.statusVerified": "Đã xác minh",
    "admin.charity.statusApproved": "Đã phê duyệt",
    "admin.charity.statusRejected": "Đã từ chối",
    "admin.charity.statusSuspended": "Đã đình chỉ",
    "admin.charity.approveTitle": "Phê duyệt tổ chức từ thiện",
    "admin.charity.rejectTitle": "Từ chối tổ chức từ thiện",
    "admin.charity.suspendTitle": "Đình chỉ tổ chức từ thiện",
    "admin.charity.reinstateTitle": "Khôi phục tổ chức từ thiện",
    "admin.charity.confirmAction": "Xác nhận thao tác",
    "admin.charity.reasonRequired": "Lý do (bắt buộc)",
    "admin.charity.reasonOptional": "Lý do (không bắt buộc)",
    "admin.charity.saving": "Đang lưu\u2026",
    "admin.charity.confirm": "Xác nhận",
    "admin.charity.noResults":
      "Không tìm thấy tổ chức từ thiện phù hợp với bộ lọc.",
    "admin.charity.unnamed": "Tổ chức chưa có tên",

    // Admin - Charity Requests page (GIV-256)
    "admin.charityRequests.title": "Yêu cầu tổ chức từ thiện",
    "admin.charityRequests.subtitle":
      "Yêu cầu do nhà tài trợ gửi cho các tổ chức chưa được nhận, nhóm theo tổ chức. Các tổ chức có lượt quan tâm cao nhất nên được ưu tiên liên hệ.",
    "admin.charityRequests.ein": "Mã số thuế",
    "admin.charityRequests.requests": "Yêu cầu",
    "admin.charityRequests.latestRequester": "Người yêu cầu gần nhất",
    "admin.charityRequests.latestRequest": "Yêu cầu gần nhất",
    "admin.charityRequests.firstRequest": "Yêu cầu đầu tiên",
    "admin.charityRequests.empty":
      "Chưa có yêu cầu tổ chức từ thiện nào được gửi.",
    "admin.charityRequests.errorTitle": "Lỗi tải yêu cầu tổ chức từ thiện",
    "admin.charityRequests.showing":
      "Hiển thị {{shown}} trong số {{total}} tổ chức duy nhất.",

    // Admin - Volunteer Validation page (GIV-256)
    "admin.validation.title": "Giám sát xác nhận tình nguyện",
    "admin.validation.totalCount": "{{count}} tổng yêu cầu",
    "admin.validation.pipelineStats": "Thống kê quy trình",
    "admin.validation.noStats": "Không có thống kê khả dụng.",
    "admin.validation.pending": "Đang chờ",
    "admin.validation.approved": "Đã phê duyệt",
    "admin.validation.rejected": "Đã từ chối",
    "admin.validation.expired": "Đã hết hạn",
    "admin.validation.avgResponseTime": "Thời gian phản hồi TB:",
    "admin.validation.expirationRate": "Tỷ lệ hết hạn:",
    "admin.validation.rejectionRate": "Tỷ lệ từ chối:",
    "admin.validation.searchPlaceholder": "Tìm tình nguyện viên, tổ chức\u2026",
    "admin.validation.requestsTab": "Yêu cầu xác nhận",
    "admin.validation.patternsTab": "Mẫu đáng ngờ",
    "admin.validation.colVolunteer": "Tình nguyện viên",
    "admin.validation.colOrganisation": "Tổ chức",
    "admin.validation.colHours": "Giờ",
    "admin.validation.colActivityDate": "Ngày hoạt động",
    "admin.validation.colHrsPerWeek": "Giờ/Tuần",
    "admin.validation.colTotalRequests": "Tổng yêu cầu",
    "admin.validation.override": "Ghi đè",
    "admin.validation.noPatterns": "Không phát hiện mẫu đáng ngờ nào.",
    "admin.validation.noRequests": "Không tìm thấy yêu cầu xác nhận.",
    "admin.validation.patternsDescription":
      "Tình nguyện viên bị đánh dấu vì báo cáo nhiều hơn ngưỡng giờ được cấu hình trong khoảng thời gian 7 ngày liên tục. Các mẫu này có thể cho thấy việc lạm dụng hệ thống giờ tự khai báo.",
    "admin.validation.overrideTitle": "Ghi đè yêu cầu xác nhận",
    "admin.validation.newStatus": "Trạng thái mới",
    "admin.validation.reasonRequired": "Lý do (bắt buộc)",
    "admin.validation.reasonPlaceholder":
      "Giải thích lý do ghi đè yêu cầu này\u2026",
    "admin.validation.saving": "Đang lưu\u2026",
    "admin.validation.confirmOverride": "Xác nhận ghi đè",
    "admin.validation.allStatuses": "Tất cả trạng thái",
    "admin.validation.colStatus": "Trạng thái",
    "admin.validation.colCreated": "Ngày tạo",

    // GIV-266: Delta translations (354 keys)
    "home.hero.title": "Quyên Góp Minh Bạch",
    "home.hero.titleAccent": "Tác Động Bền Vững",
    "home.hero.description":
      "Hoạt động từ thiện minh bạch triệt để cho thời đại số. Được xây dựng vì tác động, được hỗ trợ bởi công nghệ có thể kiểm chứng. Mọi đóng góp đều có thể truy vết từ nhà tài trợ đến đích đến.",
    "home.hero.visionTitle": "Tầm nhìn của chúng tôi",
    "home.hero.visionText":
      "Give Protocol đang kiến tạo tương lai của hoạt động quyên góp có tính chính trực cao. Chúng tôi tận dụng hạ tầng công nghệ tiên tiến để thu hẹp khoảng cách giữa nguồn vốn toàn cầu và tác động địa phương. Bằng cách tích hợp hỗ trợ tài sản số liền mạch với các phương thức quyên góp truyền thống, chúng tôi đang tạo ra hệ sinh thái tài trợ bền vững biến những khoản quyên góp một lần thành động lực hỗ trợ vĩnh cửu cho những mục đích quan trọng nhất trên thế giới.",
    "home.comingSoon": "Sắp ra mắt",
    "home.readDocs": "Đọc tài liệu",
    "home.features.sectionTitle": "Cổng vào hoạt động từ thiện minh bạch",
    "home.features.sectionSubtitle":
      "Hạ tầng đa chuỗi cho quyên góp liền mạch — tiền mã hóa hoặc tiền pháp định — với sự minh bạch hoàn toàn",
    "home.features.highEfficiency.title": "Quyên góp hiệu quả cao",
    "home.features.highEfficiency.description":
      "Đóng góp trực tiếp cho các tổ chức đã xác minh mà không có sự mơ hồ. Sổ cái tự động của chúng tôi cung cấp xác minh theo thời gian thực, đảm bảo sự hỗ trợ của bạn được triển khai chính xác nơi cần thiết nhất.",
    "home.features.equityFunds.title": "Quỹ cổ phần từ thiện",
    "home.features.equityFunds.description":
      "Vượt xa quyên góp một lần bằng cách đóng góp vào các quỹ cổ phần được quản lý thông minh. Chúng tôi sử dụng các chiến lược số hóa tinh vi, rủi ro thấp để biến vốn gốc của bạn thành dòng tài trợ vĩnh cửu, duy trì sứ mệnh từ thiện cho nhiều thế hệ.",
    "home.features.impactFunds.title": "Quỹ tác động",
    "home.features.impactFunds.description":
      "Gộp nguồn lực cho các mục đích cụ thể. Môi trường, giáo dục, xóa đói giảm nghèo — khoản quyên góp của bạn được khuếch đại thông qua hành động tập thể.",
    "home.features.verifiedOrgs.title": "Tổ chức đã xác minh",
    "home.features.verifiedOrgs.description":
      "Duyệt qua bất kỳ tổ chức đã đăng ký nào, hoặc tìm huy hiệu đã xác minh. Các tổ chức tham gia quy trình thẩm định của chúng tôi sẽ nhận được xác minh on-chain mà nhà tài trợ có thể tin tưởng.",
    "home.features.blockchainVerified.title": "Xác minh trên Blockchain",
    "home.features.blockchainVerified.description":
      "Token gắn liền linh hồn ghi nhận đóng góp tình nguyện. Kỹ năng, giờ làm việc và tác động — tất cả được ghi nhận vĩnh viễn trên chuỗi.",
    "home.features.bridgingModes.title": "Kết nối các hình thức quyên góp",
    "home.features.bridgingModes.description":
      "Dù bạn quyên góp bằng USD hay tài sản số, kiến trúc đa mạng của chúng tôi đảm bảo đóng góp của bạn di chuyển với tốc độ của thế giới hiện đại.",
    "home.roles.title": "Được xây dựng cho mọi người đang thay đổi thế giới",
    "home.roles.donors.title": "Dành cho nhà tài trợ",
    "home.roles.donors.item1":
      "Quyên góp bằng tiền mã hóa hoặc tiền pháp định — tùy bạn chọn",
    "home.roles.donors.item2": "Tham gia quản trị",
    "home.roles.donors.item3": "Xây dựng uy tín on-chain",
    "home.roles.nonprofits.title": "Dành cho tổ chức phi lợi nhuận",
    "home.roles.nonprofits.item1": "Tiếp cận nhóm nhà tài trợ mới",
    "home.roles.nonprofits.item2": "Tài trợ bền vững qua CEF",
    "home.roles.nonprofits.item3": "Báo cáo minh bạch nâng cao",
    "home.roles.volunteers.title": "Dành cho tình nguyện viên",
    "home.roles.volunteers.item1": "Hồ sơ đóng góp có thể kiểm chứng",
    "home.roles.volunteers.item2": "Chứng chỉ kỹ năng di động (SBT)",
    "home.roles.volunteers.item3": "Huy hiệu thành tích & ghi nhận",
    "home.impact.title": "Quỹ tác động theo kế hoạch",
    "home.impact.environmental.title": "Quỹ tác động môi trường",
    "home.impact.environmental.description":
      "Hỗ trợ trồng rừng, dọn dẹp đại dương và các sáng kiến năng lượng tái tạo. Quyên góp gộp được chuyển đến các tổ chức môi trường đã xác minh tạo ra tác động đo lường được.",
    "home.impact.education.title": "Quỹ cơ hội giáo dục",
    "home.impact.education.description":
      "Cung cấp học bổng, công cụ học tập số và đào tạo giáo viên. Tài trợ tập thể được khuếch đại để hỗ trợ các sáng kiến giáo dục tại các cộng đồng thiếu thốn.",
    "home.cta.title": "Sẵn sàng thay đổi cách quyên góp?",
    "home.cta.subtitle":
      "Hãy là một trong những người đầu tiên trải nghiệm hoạt động từ thiện minh bạch, được hỗ trợ bởi blockchain. Tham gia cộng đồng của chúng tôi để xây dựng một tương lai tốt đẹp hơn cho hoạt động từ thiện.",
    "home.cta.explore": "Khám phá mục đích",
    "home.nav.features": "Tính năng",
    "home.nav.impact": "Tác động",
    "home.nav.charities": "Tổ chức từ thiện",
    "home.nav.volunteer": "Tình nguyện",
    "home.footer.brand.tagline":
      "Chuyển đổi hoạt động từ thiện thông qua minh bạch blockchain và tài trợ bền vững.",
    "home.footer.product.title": "Sản phẩm",
    "home.footer.product.impactFunds": "Quỹ tác động",
    "home.footer.product.charities": "Dành cho tổ chức từ thiện",
    "home.footer.product.volunteers": "Dành cho tình nguyện viên",
    "home.footer.resources.title": "Tài nguyên",
    "home.footer.resources.whitepaper": "Sách trắng (Sắp ra mắt)",
    "home.footer.resources.blog": "Blog (Sắp ra mắt)",
    "home.footer.resources.community": "Cộng đồng (Sắp ra mắt)",
    "home.footer.connect.title": "Kết nối",
    "home.footer.connect.contact": "Liên hệ (Sắp ra mắt)",
    "home.footer.copyright":
      "Give Protocol. Đa chuỗi theo thiết kế. Được vận hành bởi các tình nguyện viên Give Protocol.",
    "auth.signin.welcomeBack": "Chào mừng trở lại",
    "auth.signin.subtitle": "Đăng nhập vào tài khoản Give Protocol của bạn",
    "auth.signin.emailPlaceholder": "Email",
    "auth.signin.passwordPlaceholder": "Mật khẩu",
    "auth.signin.submitting": "Đang đăng nhập…",
    "auth.signin.withPasskey": "Đăng nhập bằng Passkey",
    "auth.signin.withGoogle": "Tiếp tục với Google",
    "auth.signin.or": "hoặc",
    "auth.signin.newToProtocol": "Mới sử dụng Give Protocol?",
    "auth.signin.createAccount": "Tạo tài khoản →",
    "auth.signin.forgotPasswordLink": "Quên mật khẩu? →",
    "auth.signin.sslEncrypted": "Mã hóa TLS",
    "auth.signin.modeToggleLabel": "Phương thức đăng nhập",
    "auth.signin.terms": "Điều khoản",
    "auth.signin.privacy": "Quyền riêng tư",
    "auth.panel.headline": "Quyên góp thông minh, tác động minh bạch.",
    "auth.panel.subheadline":
      "Một tài khoản. Quyên góp bằng thẻ hoặc tiền mã hóa. Theo dõi từng đồng on-chain.",
    "auth.panel.statusLabel": "Trạng thái giao thức · Giai đoạn khởi nguồn",
    "auth.panel.statusDesc": "Xây dựng nền tảng cho quyên góp minh bạch",
    "auth.panel.runsOn": "Chạy trên",
    "auth.wallet.connect": "Kết nối ví",
    "auth.wallet.connecting": "Đang kết nối ví…",
    "auth.wallet.signing": "Đang ký thông điệp…",
    "auth.wallet.verifying": "Đang xác minh…",
    "auth.wallet.openingSession": "Đang mở phiên…",
    "auth.validation.emailRequired": "Vui lòng nhập địa chỉ email trước",
    "auth.validation.invalidEmail": "Vui lòng nhập địa chỉ email hợp lệ",
    "auth.validation.passwordTooShort": "Mật khẩu phải có ít nhất 8 ký tự",
    "auth.validation.passwordMismatch": "Mật khẩu không khớp",
    "auth.login.welcomeHeading": "Chào mừng đến với Give Protocol",
    "auth.login.signInOrConnect": "Đăng nhập hoặc kết nối",
    "auth.login.skipToContent": "Chuyển đến nội dung đăng nhập",
    "auth.login.donorTitle": "Đăng nhập nhà tài trợ",
    "auth.login.donorSubtitle":
      "Đăng nhập để truy cập bảng điều khiển quyên góp của bạn",
    "auth.login.charityTitle": "Cổng tổ chức phi lợi nhuận",
    "auth.login.charitySubtitle":
      "Quản lý hồ sơ tổ chức và các khoản quyên góp",
    "auth.login.back": "← Quay lại",
    "auth.login.continueDonor": "Tiếp tục với tư cách nhà tài trợ",
    "auth.login.connecting": "Đang kết nối…",
    "auth.login.connectWalletSignIn": "Kết nối ví & đăng nhập",
    "auth.login.newToPlatform": "Mới sử dụng Give Protocol?",
    "auth.login.newDonorSignUp": "Đăng ký nhà tài trợ mới",
    "auth.login.manageNonprofit": "Tôi quản lý một hồ sơ phi lợi nhuận",
    "auth.login.nonprofitTrayTitle": "Mới sử dụng Give Protocol?",
    "auth.login.createNonprofitAccount": "Tạo tài khoản tổ chức phi lợi nhuận",
    "auth.login.registerOrg": "Đăng ký tổ chức của bạn trên Give Protocol",
    "auth.login.needHelp": "Cần trợ giúp?",
    "auth.login.forgotUsernameBtn": "Quên tên đăng nhập?",
    "auth.login.forgotPasswordBtn": "Quên mật khẩu?",
    "auth.donorLogin.mismatch":
      "Không tìm thấy tài khoản nhà tài trợ. Email này được đăng ký dưới tài khoản tổ chức từ thiện. Vui lòng sử dụng cổng đăng nhập dành cho tổ chức từ thiện.",
    "auth.donorLogin.signingIn": "Đang đăng nhập…",
    "auth.donorLogin.redirecting": "Đang chuyển hướng sau {{count}}...",
    "auth.donorReg.pleaseWait": "Vui lòng chờ…",
    "auth.donorReg.signUpPasskey": "Đăng ký bằng Passkey",
    "auth.donorReg.withGoogle": "Tiếp tục với Google",
    "auth.donorReg.connectWallet": "Kết nối ví",
    "auth.donorReg.orSetPassword": "Hoặc đặt mật khẩu",
    "auth.donorReg.creating": "Đang tạo tài khoản...",
    "auth.donorReg.createAccount": "Tạo tài khoản nhà tài trợ",
    "auth.donorReg.privacyNotice": "Bằng cách tạo tài khoản, bạn đồng ý với",
    "auth.donorReg.termsLink": "Điều khoản dịch vụ",
    "auth.donorReg.privacyAnd": "của chúng tôi và xác nhận",
    "auth.donorReg.privacyLink": "Chính sách Bảo mật",
    "auth.charityLogin.mismatch":
      "Email này được đăng ký dưới tài khoản nhà tài trợ. Vui lòng đăng nhập tại cổng nhà tài trợ.",
    "auth.charityLogin.signingIn": "Đang đăng nhập...",
    "auth.charityLogin.or": "hoặc",
    "auth.charityLogin.connecting": "Đang kết nối...",
    "auth.charityLogin.connectWallet": "Kết nối ví",
    "auth.forgot.resetPassword": "Đặt lại mật khẩu",
    "auth.forgot.forgotUsername": "Quên tên đăng nhập",
    "auth.forgot.passwordDesc":
      "Nhập địa chỉ email của bạn và chúng tôi sẽ gửi liên kết đặt lại mật khẩu.",
    "auth.forgot.usernameDesc":
      "Nhập địa chỉ email của bạn và chúng tôi sẽ gửi tên đăng nhập cho bạn.",
    "auth.forgot.passwordSuccess":
      "Hướng dẫn đặt lại mật khẩu đã được gửi đến email của bạn",
    "auth.forgot.usernameSuccess":
      "Lời nhắc tên đăng nhập đã được gửi đến email của bạn",
    "auth.forgot.checkEmail": "Kiểm tra email của bạn",
    "auth.forgot.backToSignIn": "Quay lại đăng nhập",
    "auth.forgot.emailPlaceholder": "Nhập địa chỉ email của bạn",
    "auth.forgot.genericError": "Đã xảy ra lỗi. Vui lòng thử lại.",
    "auth.forgot.sending": "Đang gửi...",
    "auth.forgot.sendResetLink": "Gửi liên kết đặt lại",
    "auth.forgot.sendUsername": "Gửi tên đăng nhập",

    // Reset password (set new password page) — pending translation (GIV-367)
    "auth.resetPassword.title": "Set New Password",
    "auth.resetPassword.subtitle": "Choose a strong password for your account.",
    "auth.resetPassword.newPassword": "New Password",
    "auth.resetPassword.confirmPassword": "Confirm New Password",
    "auth.resetPassword.submit": "Update Password",
    "auth.resetPassword.updating": "Updating\u2026",
    "auth.resetPassword.mismatch": "Passwords do not match.",
    "auth.resetPassword.success": "Password updated successfully!",
    "auth.resetPassword.successSubtitle":
      "You can now sign in with your new password.",
    "auth.resetPassword.backToSignIn": "Back to Sign In",
    "auth.resetPassword.invalidLink":
      "This password reset link is invalid or has expired.",
    "auth.resetPassword.requestNew": "Request a new reset link",
    "auth.resetPassword.validating": "Validating reset link\u2026",
    "auth.orgSearch.orgNameLabel": "Tên tổ chức",
    "auth.orgSearch.searchPlaceholder": "Tìm kiếm theo tên tổ chức...",
    "auth.orgSearch.countryLabel": "Quốc gia",
    "auth.orgSearch.allCountries": "Tất cả quốc gia",
    "auth.orgSearch.searchPrompt":
      "Tìm kiếm trong cơ sở dữ liệu của chúng tôi để tìm và nhận tổ chức của bạn.",
    "auth.orgSearch.noResults": "Không tìm thấy tổ chức nào.",
    "auth.orgSearch.loadMore": "Tải thêm kết quả",
    "auth.orgSearch.cantFind": "Không tìm thấy tổ chức của bạn?",
    "auth.orgSearch.registerManually": "Đăng ký thủ công",
    "charity.claim.orgDetails": "Thông tin tổ chức (từ Cơ quan đăng ký)",
    "charity.claim.orgNameLabel": "Tên",
    "charity.claim.einLabel": "Mã số thuế",
    "charity.claim.locationLabel": "Địa điểm",
    "charity.claim.contactInfo": "Thông tin liên hệ",
    "charity.claim.contactName": "Tên liên hệ",
    "charity.claim.contactEmail": "Email liên hệ",
    "charity.claim.accountSecurity": "Bảo mật tài khoản",
    "charity.claim.password": "Mật khẩu",
    "charity.claim.confirmPassword": "Xác nhận mật khẩu",
    "charity.claim.backToSearch": "Quay lại tìm kiếm",
    "charity.claim.creating": "Đang tạo tài khoản...",
    "charity.claim.submit": "Nhận tổ chức",
    "charity.claim.validation.name": "Tên phải có từ 2 đến 100 ký tự",
    "charity.claim.validation.email": "Vui lòng nhập địa chỉ email hợp lệ",
    "charity.claim.validation.password": "Mật khẩu phải có ít nhất 8 ký tự",
    "charity.claim.validation.confirmPassword": "Mật khẩu không khớp",
    "charity.claim.validation.fix": "Vui lòng sửa các lỗi xác thực",
    "charity.claim.useAsPublicEmail":
      "Sử dụng email của tôi làm email liên hệ công khai của tổ chức",
    "charity.claim.publicContactEmail": "Email liên hệ công khai của tổ chức",
    "charity.claim.privacyNotice":
      "Email/số điện thoại cá nhân của người ký chỉ được sử dụng để xác minh và không hiển thị cho người dùng nền tảng khác. Email liên hệ công khai sẽ được hiển thị trên hồ sơ tổ chức của bạn.",
    "charity.claim.secondContactTitle": "Người liên hệ thứ hai",
    "charity.claim.secondContactName": "Tên người liên hệ thứ hai",
    "charity.claim.secondContactEmail": "Email người liên hệ thứ hai",
    "charity.claim.secondContactHint":
      "Một người khác, được thông báo khi ví hoặc chi tiết thanh toán của tổ chức từ thiện của bạn thay đổi.",
    "charity.claim.validation.secondEmailDistinct":
      "Email của người liên hệ thứ hai phải khác với email chính",
    "charity.claim.error.creation": "Tạo tài khoản thất bại",
    "charity.claim.error.generic": "Không thể tạo tài khoản",
    "charity.vetting.orgDetails": "Thông tin tổ chức",
    "charity.vetting.orgName": "Tên tổ chức",
    "charity.vetting.description": "Mô tả",
    "charity.vetting.taxId": "Mã số thuế hoặc mã đăng ký",
    "charity.vetting.countryLabel": "Quốc gia",
    "charity.vetting.selectCountry": "Chọn quốc gia",
    "charity.vetting.address": "Địa chỉ",
    "charity.vetting.streetAddress": "Địa chỉ đường",
    "charity.vetting.city": "Thành phố",
    "charity.vetting.state": "Tỉnh/Thành phố",
    "charity.vetting.postalCode": "Mã bưu chính",
    "charity.vetting.contactInfo": "Thông tin liên hệ",
    "charity.vetting.contactName": "Tên liên hệ",
    "charity.vetting.contactEmail": "Email liên hệ",
    "charity.vetting.accountSecurity": "Bảo mật tài khoản",
    "charity.vetting.password": "Mật khẩu",
    "charity.vetting.confirmPassword": "Xác nhận mật khẩu",
    "charity.vetting.submitting": "Đang gửi đơn đăng ký...",
    "charity.vetting.submit": "Gửi đơn đăng ký tổ chức từ thiện",
    "charity.vetting.validation.orgName":
      "Tên tổ chức phải có từ 2 đến 100 ký tự",
    "charity.vetting.validation.contactName":
      "Tên liên hệ phải có từ 2 đến 100 ký tự",
    "charity.vetting.validation.email": "Vui lòng nhập địa chỉ email hợp lệ",
    "charity.vetting.validation.password": "Mật khẩu phải có ít nhất 8 ký tự",
    "charity.vetting.validation.confirmPassword": "Mật khẩu không khớp",
    "charity.vetting.validation.description": "Mô tả là bắt buộc",
    "charity.vetting.validation.category": "Danh mục là bắt buộc",
    "charity.vetting.validation.taxId": "Mã số thuế là bắt buộc",
    "charity.vetting.validation.streetAddress": "Địa chỉ đường là bắt buộc",
    "charity.vetting.validation.city": "Thành phố là bắt buộc",
    "charity.vetting.validation.country": "Quốc gia là bắt buộc",
    "charity.vetting.validation.fix": "Vui lòng sửa các lỗi xác thực",
    "charity.vetting.error.generic": "Gửi đơn đăng ký thất bại",
    "charity.vetting.privacyNotice":
      "Bằng cách gửi đơn đăng ký này, bạn đồng ý với",
    "charity.vetting.termsLink": "Điều khoản dịch vụ",
    "charity.vetting.privacyAnd": "của chúng tôi và xác nhận",
    "charity.vetting.privacyLink": "Chính sách Bảo mật",
    "common.email": "Email",
    "common.password": "Mật khẩu",
    "common.confirmPassword": "Xác nhận mật khẩu",
    "footer.brand.tagline":
      "Xóa bỏ rào cản cho hoạt động quyên góp từ thiện bền vững.",
    "footer.resources.title": "Tài nguyên",
    "footer.resources.faq": "Câu hỏi thường gặp",
    "footer.resources.about": "Về chúng tôi",
    "footer.legal.title": "Pháp lý",
    "footer.legal.terms": "Điều khoản dịch vụ",
    "footer.legal.privacy": "Chính sách quyền riêng tư",
    "footer.legal.cookiePreferences": "Tùy chọn cookie",
    "consent.banner.ariaLabel": "Đồng ý cookie",
    "consent.banner.body":
      "Chúng tôi sử dụng Google Analytics 4 (Google LLC, Hoa Kỳ) và Sentry (Functional Software, Hoa Kỳ/EU) để hiểu cách ứng dụng được sử dụng và phát hiện lỗi. Không có địa chỉ email, địa chỉ ví hoặc tên nhà tài trợ nào được chia sẻ. Bạn có thể rút lại sự đồng ý bất cứ lúc nào.",
    "consent.banner.privacyLink": "Chính sách quyền riêng tư",
    "consent.banner.acceptAll": "Chấp nhận tất cả",
    "consent.banner.decline": "Từ chối không thiết yếu",
    "consent.banner.customize": "Tùy chỉnh",
    "consent.modal.title": "Tùy chọn cookie",
    "consent.modal.essentialTitle": "Thiết yếu",
    "consent.modal.essentialDesc":
      "Cần thiết cho các tính năng cốt lõi của trang web như điều hướng và xác thực. Không thể tắt.",
    "consent.modal.essentialAlwaysOn": "Cookie thiết yếu — luôn bật",
    "consent.modal.analyticsTitle":
      "Phân tích (Google Analytics 4 · Hoa Kỳ, Sentry · Hoa Kỳ/EU)",
    "consent.modal.analyticsDesc":
      "Cookie phân tích giúp chúng tôi hiểu những trang nào được truy cập và cách người dùng điều hướng trong ứng dụng. Chúng tôi sử dụng Google Analytics 4 \u2014 mã nhận dạng phiên, URL trang, siêu dữ liệu thiết bị/trình duyệt, vị trí ước tính từ IP ẩn danh (Google LLC, Hoa Kỳ; SCCs + EU\u2013US Data Privacy Framework). Sentry \u2014 dấu vết lỗi ẩn danh và siêu dữ liệu trình duyệt để giám sát độ tin cậy (Functional Software, EU/Hoa Kỳ; cơ chế chuyển giao đang chờ xử lý). Không có địa chỉ email, địa chỉ ví hoặc tên nhà tài trợ nào được chia sẻ với bất kỳ bên xử lý nào.",
    "consent.modal.analyticsOn": "Phân tích và ghi nhận lỗi — bật",
    "consent.modal.analyticsOff": "Phân tích và ghi nhận lỗi — tắt",
    "consent.modal.cancel": "Hủy",
    "consent.modal.save": "Lưu tùy chọn",
    "footer.connect.title": "Kết nối",
    "footer.copyright": "Give Protocol. Mọi quyền được bảo lưu.",
    "nav.signIn": "Đăng nhập",
    "nav.signOut": "Đăng xuất",
    "nav.privacy": "Quyền riêng tư",
    "auth.signup.heading": "Tạo tài khoản của bạn",
    "auth.signup.subtitle": "Tham gia phong trào quyên góp minh bạch",
    "auth.signup.displayName": "Tên hiển thị",
    "auth.signup.emailPlaceholder": "Email",
    "auth.signup.passwordPlaceholder": "Mật khẩu",
    "auth.signup.confirmPasswordPlaceholder": "Xác nhận mật khẩu",
    "auth.signup.submit": "Tạo tài khoản",
    "auth.signup.submitting": "Đang tạo tài khoản…",
    "auth.signup.withPasskey": "Đăng ký bằng Passkey",
    "auth.signup.withGoogle": "Tiếp tục với Google",
    "auth.signup.connectWallet": "Kết nối ví",
    "auth.signup.orSetPassword": "Hoặc đặt mật khẩu",
    "auth.signup.alreadyHaveAccount": "Đã có tài khoản?",
    "auth.signup.signInLink": "Đăng nhập",
    "auth.signup.manageNonprofit": "Quản lý tổ chức phi lợi nhuận?",
    "auth.signup.trustText": "Dữ liệu của bạn được bảo vệ bởi",
    "auth.signup.and": "và",
    "auth.signup.privacyPolicy": "Chính sách quyền riêng tư",
    "auth.signup.panel.headline": "Quyên góp mà bạn có thể xác minh.",
    "browse.hero.title": "Quyên góp, xác minh on-chain.",
    "browse.hero.subtitle":
      "Khám phá các tổ chức đã được kiểm duyệt, đóng góp qua thẻ hoặc tài sản kỹ thuật số và thấy tác động cụ thể từ thời gian và nguồn lực của bạn.",
    "browse.stats.networks": "Mạng được hỗ trợ",
    "browse.stats.sectors": "Lĩnh vực từ thiện",
    "browse.stats.verifiedOrgs": "Tổ chức đã xác minh",
    "browse.stats.volunteerHours": "Giờ tình nguyện",
    "browse.verified": "Đã xác minh",
    "browse.donate": "Quyên góp",
    "browse.viewProfile": "Xem hồ sơ",
    "browse.filter.ariaLabel": "Lọc tổ chức từ thiện",
    "browse.filter.searchAria": "Tìm kiếm tổ chức từ thiện",
    "browse.filter.locationAria": "Tìm kiếm địa điểm",
    "browse.results.ariaLabel": "Kết quả tổ chức từ thiện",
    "browse.tabs.charities": "Tổ chức từ thiện",
    "browse.tabs.causes": "Mục đích",
    "browse.tabs.funds": "Quỹ danh mục",
    "browse.tabs.ariaLabel": "Danh mục duyệt",
    "browse.featured.heading": "Tổ chức nổi bật",
    "browse.featured.ariaLabel": "Tổ chức nổi bật",
    "browse.featured.nextAria": "Tổ chức nổi bật tiếp theo",
    "browse.causes.heading": "Mục đích nổi bật",
    "browse.causes.ariaLabel": "Mục đích nổi bật",
    "browse.causes.badge": "Mục đích",
    "browse.causes.raised": "đã quyên góp",
    "browse.causes.percentOf": "% của",
    "browse.causes.by": "bởi",
    "browse.causes.supportCta": "Ủng hộ mục đích này",
    "browse.causes.giveCta": "Quyên góp",
    "browse.causes.nextAria": "Mục đích nổi bật tiếp theo",
    "browse.funds.heading": "Quỹ danh mục",
    "browse.funds.ariaLabel": "Quỹ danh mục",
    "browse.funds.badge": "Quỹ danh mục",
    "browse.funds.charity": "tổ chức",
    "browse.funds.charities": "tổ chức",
    "browse.funds.donateCta": "Quyên góp cho quỹ",
    "browse.funds.nextAria": "Quỹ danh mục tiếp theo",
    "portfolio.notFound.title": "Không tìm thấy quỹ danh mục",
    "portfolio.notFound.body":
      "Quỹ danh mục bạn đang tìm không tồn tại hoặc không còn hoạt động.",
    "portfolio.supportedOrgs": "Các tổ chức được hỗ trợ",
    "browse.charity.einLabel": "Mã số thuế",
    "browse.charity.einDisplay": "Mã số thuế: {{value}}",
    "browse.charity.nteeLabel": "Mã ngành",
    "browse.charity.deductibilityLabel": "Khấu trừ thuế",
    "browse.charity.onPlatform": "Trên nền tảng",
    "browse.charity.loading": "Đang tải…",
    "browse.charity.loadMore": "Tải thêm",
    "browse.filter.searchPlaceholder": "Tìm kiếm tổ chức từ thiện...",
    "browse.filter.locationPlaceholder":
      "Thành phố, tiểu bang hoặc quốc gia...",
    "browse.whyGiveProtocol.heading": "Tại sao chọn Give Protocol?",
    "browse.whyGiveProtocol.verified.title":
      "Tổ chức phi lợi nhuận đã xác minh",
    "browse.whyGiveProtocol.verified.description":
      "Mỗi tổ chức được đối chiếu với hồ sơ công khai trước khi xuất hiện trên nền tảng.",
    "browse.whyGiveProtocol.onchain.title": "Minh bạch trên chuỗi",
    "browse.whyGiveProtocol.onchain.description":
      "Các khoản quyên góp được ghi lại trên blockchain để bạn có thể theo dõi tác động từ ví đến mục đích.",
    "browse.whyGiveProtocol.volunteer.title": "Tặng thời gian, không chỉ tiền",
    "browse.whyGiveProtocol.volunteer.description":
      "Giờ tình nguyện được xác minh bởi tổ chức từ thiện và tính vào uy tín giao thức của bạn.",
    "browse.news.heading": "Tin Tức Nền Tảng",
    "admin.news.deleteConfirmBody": "“{{title}}” sẽ bị xóa vĩnh viễn. Không thể hoàn tác thao tác này.",
    "admin.news.deleteConfirmTitle": "Xóa tin tức?",
    "admin.news.saveFailed": "Không thể lưu thay đổi của bạn. Vui lòng thử lại.",
    "admin.news.urlHelp": "Tùy chọn. Để trống để hiển thị tin tức không có liên kết.",
    "admin.news.urlInvalid": "Nhập địa chỉ https:// đầy đủ hoặc đường dẫn bắt đầu bằng /.",
    "browse.carousel.error": "Không thể tải phần này. Vui lòng làm mới trang và thử lại.",
    "browse.carousel.goToPage": "Đến trang {{page}}",
    "browse.carousel.pageLabel": "Trang {{current}} trên {{total}}",
    "browse.carousel.pause": "Tạm dừng tự động chuyển",
    "browse.carousel.play": "Tiếp tục tự động chuyển",
    "browse.causes.empty": "Chưa có mục đích nào. Hãy quay lại sớm nhé!",
    "browse.causes.prevAria": "Mục đích nổi bật trước đó",
    "browse.causes.searchPlaceholder": "Tìm kiếm mục đích...",
    "browse.causes.subheading": "Hỗ trợ các dự án cụ thể tạo ra tác động thực sự.",
    "browse.charity.registryIdDisplay": "Mã đăng ký: {{value}}",
    "browse.featured.empty": "Chưa có tổ chức nổi bật. Hãy dùng ô tìm kiếm phía trên để tìm một tổ chức từ thiện.",
    "browse.featured.prevAria": "Tổ chức nổi bật trước đó",
    "browse.featured.subheading": "Điểm qua các tổ chức từ thiện đã xác minh trên Give Protocol.",
    "browse.filter.addLocation": "Thêm địa điểm",
    "browse.filter.impactNotice": "Bộ lọc theo địa điểm tác động chưa khả dụng, nên kết quả không được thu hẹp theo địa điểm tác động.",
    "browse.filter.locationHint": "Nhấn Enter hoặc chọn Thêm để áp dụng địa điểm.",
    "browse.filter.minChars": "Nhập ít nhất 2 ký tự để tìm kiếm.",
    "browse.funds.empty": "Chưa có quỹ danh mục nào. Hãy quay lại sớm nhé!",
    "browse.funds.prevAria": "Quỹ danh mục trước đó",
    "browse.funds.searchPlaceholder": "Tìm kiếm quỹ danh mục...",
    "browse.funds.subheading": "Các danh mục quyên góp được tuyển chọn, phân bổ khoản quyên góp cho các tổ chức từ thiện đã xác minh.",
    "browse.registry.badge": "Đã đăng ký tại {{registry}}",
    "browse.results.empty": "Không có tổ chức nào khớp với tìm kiếm này. Hãy thử từ khóa khác hoặc thêm bộ lọc địa điểm.",
    "browse.results.error": "Không thể thực hiện tìm kiếm. Vui lòng thử lại.",
    "browse.search.noMatches": "Không có kết quả nào khớp với “{{query}}”.",
    "browse.category.A": "Nghệ thuật & Văn hóa",
    "browse.category.B": "Giáo dục",
    "browse.category.C": "Môi trường",
    "browse.category.D": "Phúc lợi động vật",
    "browse.category.E": "Sức khỏe",
    "browse.category.F": "Sức khỏe tâm thần",
    "browse.category.G": "Nghiên cứu y học",
    "browse.category.H": "Nghiên cứu y sinh",
    "browse.category.I": "Tội phạm & Pháp lý",
    "browse.category.J": "Việc làm",
    "browse.category.K": "Thực phẩm & Dinh dưỡng",
    "browse.category.L": "Nhà ở",
    "browse.category.M": "An toàn công cộng",
    "browse.category.N": "Giải trí",
    "browse.category.O": "Phát triển thanh thiếu niên",
    "browse.category.P": "Dịch vụ nhân sinh",
    "browse.category.Q": "Quốc tế",
    "browse.category.R": "Quyền công dân",
    "browse.category.S": "Phát triển cộng đồng",
    "browse.category.T": "Từ thiện xã hội",
    "browse.category.U": "Khoa học & Công nghệ",
    "browse.category.V": "Khoa học xã hội",
    "browse.category.W": "Chính sách công",
    "browse.category.X": "Tôn giáo",
    "browse.category.Y": "Lợi ích tương hỗ",
    "browse.category.default": "Tổ chức phi lợi nhuận",
    "cause.causes": "Mục đích",
    "cause.createNew": "Tạo mới",
    "cause.noCausesTitle": "Chưa có mục đích nào",
    "cause.name": "Tên",
    "cause.description": "Mô tả",
    "cause.category": "Danh mục",
    "cause.targetAmount": "Số tiền mục tiêu",
    "cause.headerImage": "Ảnh tiêu đề",
    "cause.impact": "Tác động",
    "cause.impactHelp": "Mô tả tác động dự kiến của mục đích này.",
    "cause.location": "Địa điểm",
    "cause.timeline": "Thời gian thực hiện",
    "cause.partners": "Đối tác",
    "cause.limitReached": "Đã đạt giới hạn mục đích",
    "impact.statistics": "Thống kê tác động",
    "impact.statLabel": "Nhãn",
    "impact.statValue": "Giá trị",
    "impact.missionStatement": "Tuyên bố sứ mệnh",
    "impact.missionPlaceholder": "Sứ mệnh của chúng tôi là...",
    "impact.highlights": "Điểm nổi bật về tác động",
    "impact.highlight": "Điểm nổi bật tác động",
    "impact.addHighlight": "Thêm điểm nổi bật",
    "impact.profile": "Hồ sơ tác động",
    "impact.loadError": "Không thể tải hồ sơ tác động",
    "impact.saveError": "Không thể lưu hồ sơ tác động",
    "impact.saveSuccess": "Hồ sơ tác động đã được lưu thành công",
    "organization.yearFounded": "Năm thành lập",
    "organization.address": "Địa chỉ",
    "organization.street": "Địa chỉ đường",
    "organization.city": "Thành phố",
    "organization.stateProvince": "Tỉnh/Thành phố",
    "organization.postalCode": "Mã bưu chính",
    "organization.country": "Quốc gia",
    "organization.contactInfo": "Thông tin liên hệ",
    "organization.phone": "Điện thoại",
    "organization.email": "Email",
    "organization.website": "Trang web",
    "organization.socialMedia": "Mạng xã hội",
    "organization.publicFeed": "Bản tin công khai",
    "organization.communityMedia": "Cộng đồng & Truyền thông",
    "organization.profile": "Hồ sơ tổ chức",
    "organization.loadError": "Không thể tải hồ sơ tổ chức",
    "organization.saveError": "Không thể lưu hồ sơ tổ chức",
    "common.remove": "Xóa",
    "common.saveChanges": "Lưu thay đổi",
    "dashboard.thisMonth": "Tháng này",
    "dashboard.verified": "Tình nguyện viên đã xác minh",
    "dashboard.hoursLogged": "Giờ đã ghi nhận",
    "dashboard.endorsements": "Xác nhận",
    "dashboard.organizationsHelped": "Tổ chức đã hỗ trợ",
    "dashboard.yourOrganizationsHelped": "Tổ chức bạn đã hỗ trợ",
    "transactions.createCampaign": "Tạo chiến dịch đầu tiên của bạn",
    "contributions.emptyTitle": "Hành trình quyên góp của bạn bắt đầu từ đây",
    "contributions.browseCharities": "Duyệt tổ chức từ thiện",
    "charity.profile.verified501c3": "Tổ chức phi lợi nhuận đã xác minh",
    "charity.profile.verified501c3Tooltip":
      "Tổ chức 501(c)(3) đã đăng ký — các khoản quyên góp có thể được khấu trừ thuế tại Hoa Kỳ",
    "charity.profile.statusClaimed": "Đã được nhận",
    "charity.profile.statusUnclaimed":
      "Chưa được nhận — chỉ có dữ liệu đăng ký công khai",
    "charity.profile.statusIrsVerified":
      "Tổ chức phi lợi nhuận đã được IRS xác minh",
    "charity.profile.requestWidget.unclaimedBody":
      "Tổ chức này chưa nhận quyền quản lý hồ sơ trên Give Protocol. Quyên góp sẽ khả dụng sau khi tổ chức nhận quyền quản lý hồ sơ và hoàn tất thiết lập ví.",
    "charity.profile.rowEin": "Mã số thuế",
    "charity.profile.rowName": "Tên",
    "charity.profile.rowLocation": "Địa điểm",
    "charity.profile.rowRulingYear": "Năm đăng ký",
    "charity.profile.rowNteeCode": "Mã ngành",
    "charity.profile.rowDeductibility": "Khấu trừ thuế",
    "charity.profile.rowAffiliation": "Liên kết",
    "charity.profile.rowClassification": "Phân loại",
    "charity.profile.rowFoundation": "Loại quỹ",
    "charity.profile.rowActivityCodes": "Mã hoạt động",
    "charity.profile.rowOrgType": "Loại tổ chức",
    "charity.profile.rowSubsection": "Tiểu mục",
    "charity.profile.rowStatus": "Trạng thái",
    "charity.profile.registryRecord": "Hồ sơ công khai đăng ký",
    "charity.profile.einDisplay": "Mã số thuế",
    "charity.profile.charityNotFoundByTaxId":
      "Chúng tôi không tìm thấy tổ chức từ thiện nào có mã số thuế này.",
    "charity.profile.registeredNonprofit": "Tổ chức phi lợi nhuận đã đăng ký",
    "charity.profile.registeredYear": "Đăng ký năm {{year}}",
    "charity.profile.shareAria": "Chia sẻ",
    "charity.profile.copied": "Đã sao chép!",
    "charity.profile.about": "Giới thiệu",
    "charity.profile.claimProfile": "Nhận hồ sơ này",
    "charity.profile.noDescription": "Chưa có mô tả.",
    "charity.profile.toAddOne": "để thêm mô tả.",
    "charity.profile.contact": "Liên hệ",
    "charity.profile.donate.support": "Ủng hộ",
    "charity.profile.donate.walletUnset":
      "Tổ chức này chưa thiết lập ví nhận chính thức.",
    "charity.profile.donate.walletPending":
      "Tổ chức này đang hoàn tất thiết lập ví — quyên góp tạm thời không khả dụng.",
    "charity.profile.donate.walletLegacy":
      "Tổ chức này đang sử dụng địa chỉ ví cũ.",
    "charity.profile.donate.feeNote":
      "Phí nền tảng 0% cho quyên góp trực tiếp. Phí mạng áp dụng.",
    "charity.profile.donate.jurisdictionUnavailable":
      "Quyên góp cho các tổ chức từ thiện ngoài Hoa Kỳ hiện chưa khả dụng trên Give Protocol.",
    "portfolio.title": "Quỹ danh mục",
    "settings.displayPreferences": "Tùy chọn hiển thị",
    "settings.theme": "Giao diện",
    "settings.light": "Sáng",
    "settings.dark": "Tối",
    "auth.toast.welcomeBack": "Welcome back, {{firstName}}",
    "auth.toast.youreSignedIn": "You're signed in.",
    "auth.toast.walletConnected": "Wallet connected",
    "auth.toast.signedInWith": "Signed in with {{address}}.",
    "auth.toast.signedOut": "Signed out",
    "auth.toast.signInFailed": "Sign-in failed",
    "auth.toast.signOutFailed": "Sign-out failed",
    "donation.toast.received": "Donation received",
    "donation.toast.receivedMessage":
      "Thank you — your tax receipt is on the way.",
    "donation.toast.submitted": "Transaction submitted",
    "donation.toast.submittedMessage": "Waiting for on-chain confirmation…",
    "donation.toast.confirmed": "Donation confirmed",
    "donation.toast.confirmedMessage":
      "Your contribution is recorded on-chain.",
    "donation.toast.failed": "Donation failed",

    // Art. 9(2)(a) donation consent (GIV-655)
    "donation.art9Consent.statement":
      "Tôi hiểu rằng hồ sơ quyên góp của tôi liên kết tôi với {{charity}}. Trong trường hợp điều này có thể cho thấy sự liên kết tôn giáo, chính trị hoặc triết học, tôi đồng ý rõ ràng cho Give Protocol xử lý hồ sơ này để hoàn tất và quản lý khoản quyên góp của tôi.",
    "donation.art9Consent.label": "Đồng ý dữ liệu quyên góp",
    "donation.art9Consent.required":
      "Bạn phải đồng ý với việc xử lý dữ liệu quyên góp để tiếp tục.",

    "charity.toast.verificationEmailSent": "Verification email sent",
    "charity.toast.verificationEmailMessage":
      "Check your inbox — the link expires in 24 hours.",
    "charity.toast.submissionFailed": "Submission failed",

    "privacy.security.auditLog":
      "Là biện pháp kỹ thuật theo Điều 32 của GDPR, chúng tôi ghi nhật ký và giám sát quyền truy cập quản trị vào dữ liệu cá nhân — bao gồm hành động đã thực hiện và thời điểm xảy ra — để phát hiện truy cập trái phép, chứng minh trách nhiệm giải trình và tái dựng các sự kiện trong trường hợp không mong muốn xảy ra vi phạm dữ liệu cá nhân (Điều 34). Dữ liệu cá nhân của nhà tài trợ không được sao chép vào các nhật ký truy cập quản trị này. Nhật ký truy cập quản trị khác biệt với nhật ký xác thực và bảo mật được mô tả trong §7.1; thời hạn lưu giữ của chúng được quản lý bởi Hồ sơ Hoạt động Xử lý nội bộ của chúng tôi.",

    // Remaining i18n keys — batch translation
    "admin.auditTrail.filterByAction": "Lọc theo hành động",
    "admin.auditTrail.allActions": "Tất cả hành động",
    "admin.auditTrail.action.charityStatusChange":
      "Thay đổi trạng thái tổ chức từ thiện",
    "admin.auditTrail.action.userStatusChange":
      "Thay đổi trạng thái người dùng",
    "admin.auditTrail.action.donationFlag": "Gắn cờ quyên góp",
    "admin.auditTrail.action.donationFlagResolve": "Giải quyết cờ quyên góp",
    "admin.auditTrail.action.validationOverride": "Ghi đè xác thực",
    "admin.auditTrail.action.configChange": "Thay đổi cấu hình",
    "admin.auditTrail.action.verificationApprove": "Phê duyệt xác minh",
    "admin.auditTrail.action.verificationReject": "Từ chối xác minh",
    "admin.auditTrail.action.charitySuspend": "Tạm ngưng tổ chức từ thiện",
    "admin.auditTrail.action.charityReinstate": "Khôi phục tổ chức từ thiện",
    "admin.auditTrail.action.userSuspend": "Tạm ngưng người dùng",
    "admin.auditTrail.action.userReinstate": "Khôi phục người dùng",
    "admin.auditTrail.action.userBan": "Cấm người dùng",
    "admin.auditTrail.action.viewPii": "Xem thông tin cá nhân (PII)",
    "admin.auditTrail.action.viewPiiList":
      "Xem danh sách thông tin cá nhân (PII)",
    "admin.auditTrail.viewedEntity":
      "Quản trị viên {{adminId}} đã xem {{entityType}} {{entityId}}",
    "admin.auditTrail.viewedList":
      "Quản trị viên {{adminId}} đã xem danh sách {{entityType}} (trang {{page}}, bộ lọc: {{filters}})",
    "admin.auditTrail.viewedListNoFilters":
      "Quản trị viên {{adminId}} đã xem danh sách {{entityType}} (trang {{page}})",
    "admin.actions.platformNews": "Tin tức nền tảng",
    "admin.actions.platformNewsDesc":
      "Quản lý các mục tin tức trên trang duyệt xem",
    "admin.news.activate": "Kích hoạt {{title}}",
    "admin.news.activated": "Đã đăng mục tin tức",
    "admin.news.activeLabel": "Đã đăng (hiển thị công khai)",
    "admin.news.categoryLabel": "Danh mục",
    "admin.news.contentLabel": "Nội dung / Đoạn trích",
    "admin.news.contentPlaceholder": "Mô tả ngắn gọn về mục tin tức...",
    "admin.news.createNews": "Tạo mục tin tức",
    "admin.news.createNewsBtn": "Tạo tin tức",
    "admin.news.created": "Đã tạo mục tin tức",
    "admin.news.dateLabel": "Ngày đăng",
    "admin.news.deactivate": "Hủy kích hoạt {{title}}",
    "admin.news.deactivated": "Đã ẩn mục tin tức",
    "admin.news.deleteItem": "Xóa {{title}}",
    "admin.news.deleted": "Đã xóa mục tin tức",
    "admin.news.editItem": "Chỉnh sửa {{title}}",
    "admin.news.editNews": "Chỉnh sửa mục tin tức",
    "admin.news.imageLabel": "URL hình ảnh (tùy chọn)",
    "admin.news.imagePlaceholder": "https://...",
    "admin.news.inactive": "Không hoạt động",
    "admin.news.newItem": "Mục mới",
    "admin.news.noItemsMessage":
      "Tạo mục tin tức đầu tiên của bạn để chia sẻ cập nhật với cộng đồng",
    "admin.news.noItemsYet": "Chưa có mục tin tức nào",
    "admin.news.publishedOn": "Đã đăng {{date}}",
    "admin.news.saving": "Đang lưu...",
    "admin.news.subtitle":
      "Quản lý các mục tin tức hiển thị trên trang duyệt xem công khai",
    "admin.news.title": "Tin tức nền tảng",
    "admin.news.titleLabel": "Tiêu đề",
    "admin.news.titlePlaceholder": "vd: Báo cáo tác động hàng quý",
    "admin.news.updateNews": "Cập nhật tin tức",
    "admin.news.updated": "Đã cập nhật mục tin tức",
    "admin.news.urlLabel": "URL liên kết",
    "admin.news.urlPlaceholder": "https://example.org/article",
    "charity.walletBadge.institutionalLabel":
      "Được lưu giữ tại {{custodianName}}",
    "charity.walletBadge.institutionalTooltip":
      "Các khoản quyên góp được chuyển đến ví do đơn vị lưu ký tổ chức đủ điều kiện nắm giữ.",
    "charity.walletBadge.safeLabel":
      "Ví kho bạc đa chữ ký · {{threshold}}/{{count}} người ký",
    "charity.walletBadge.safeTooltip":
      "Các khoản quyên góp được chuyển đến ví đa chữ ký yêu cầu nhiều phê duyệt trước khi tiền có thể được chuyển.",
    "wallet.eoa.chain": "Mạng lưới",
    "wallet.eoa.checkAuthorized":
      "Tôi được tổ chức của mình ủy quyền để chỉ định ví này làm địa chỉ nhận cho các khoản quyên góp từ thiện.",
    "wallet.eoa.checkRisk":
      "Tôi hiểu rằng ví một chữ ký mang rủi ro cao hơn ví đa chữ ký, và việc mất khóa riêng tư đồng nghĩa với việc mất tiền vĩnh viễn.",
    "wallet.eoa.confirmSubtitle":
      "Vui lòng xác nhận các điều sau trước khi đăng ký ví này.",
    "wallet.eoa.confirmTitle": "Xác nhận cuối cùng",
    "wallet.eoa.connectFirst": "Vui lòng kết nối ví của bạn trước.",
    "wallet.eoa.connectWallet": "Kết nối ví",
    "wallet.eoa.missingSignature": "Thiếu chữ ký. Vui lòng quay lại và ký lại.",
    "wallet.eoa.proceedAnyway": "Tôi đã hiểu, tiếp tục",
    "wallet.eoa.register": "Đăng ký ví",
    "wallet.eoa.registering": "Đang đăng ký...",
    "wallet.eoa.rejected": "Yêu cầu ký đã bị từ chối.",
    "wallet.eoa.riskParagraph1":
      "Ví một chữ ký (EOA) được kiểm soát bởi một khóa riêng tư duy nhất. Nếu khóa đó bị mất, bị đánh cắp hoặc bị xâm phạm, tất cả số tiền gửi đến ví này sẽ không thể khôi phục vĩnh viễn.",
    "wallet.eoa.riskParagraph2":
      "Đối với quỹ của tổ chức, chúng tôi khuyến nghị mạnh mẽ nên sử dụng ví Safe đa chữ ký thay thế. Ví đa chữ ký yêu cầu nhiều phê duyệt cho mỗi giao dịch, giúp bảo vệ khỏi các điểm lỗi đơn lẻ.",
    "wallet.eoa.riskParagraph3":
      "Bằng việc tiếp tục, bạn xác nhận rằng Give Protocol không chịu trách nhiệm về bất kỳ tổn thất tiền nào do khóa riêng tư bị xâm phạm, mất mát hoặc quản lý sai.",
    "wallet.eoa.riskTitle": "Ví một chữ ký: rủi ro quan trọng",
    "wallet.eoa.signError": "Ký thông báo không thành công. Vui lòng thử lại.",
    "wallet.eoa.signMessage": "Ký thông báo xác minh",
    "wallet.eoa.signSubtitle":
      "Kết nối ví của bạn và ký một thông báo để chứng minh bạn kiểm soát địa chỉ này.",
    "wallet.eoa.signTitle": "Kết nối và ký",
    "wallet.eoa.useMultisig": "Sử dụng ví đa chữ ký thay thế",
    "wallet.eoa.walletConnection": "Ví",
    "wallet.eoa.walletToRegister": "Ví cần đăng ký",
    "wallet.institutional.address": "Địa chỉ ví",
    "wallet.institutional.attestation": "Tài liệu chứng thực",
    "wallet.institutional.attestationHelp":
      "Tải lên tệp PDF, JPEG hoặc PNG (tối đa 10MB) chứng minh mối quan hệ lưu ký của bạn.",
    "wallet.institutional.backToWallets": "Quay lại danh sách ví",
    "wallet.institutional.chain": "Mạng lưới",
    "wallet.institutional.chooseFile": "Chọn tệp hoặc kéo & thả",
    "wallet.institutional.custodian": "Đơn vị lưu ký",
    "wallet.institutional.fileTooLarge": "Tệp phải nhỏ hơn 10MB.",
    "wallet.institutional.invalidAddress":
      "Vui lòng nhập địa chỉ Ethereum hợp lệ (0x...)",
    "wallet.institutional.invalidFileType":
      "Vui lòng tải lên tệp PDF, JPEG hoặc PNG.",
    "wallet.institutional.removeFile": "Xóa tệp",
    "wallet.institutional.selectCustodian": "Vui lòng chọn một đơn vị lưu ký.",
    "wallet.institutional.selectCustodianOption": "Chọn đơn vị lưu ký...",
    "wallet.institutional.submit": "Gửi để xem xét",
    "wallet.institutional.submittedDesc":
      "Đăng ký ví lưu ký tổ chức của bạn đang được xem xét. Bạn sẽ nhận được email trong vòng 3 ngày làm việc.",
    "wallet.institutional.submittedTitle": "Đã gửi ví để xem xét",
    "wallet.institutional.submitting": "Đang gửi...",
    "wallet.institutional.subtitle":
      "Cung cấp thông tin ví do đơn vị lưu ký quản lý và tải lên tài liệu chứng thực để xác minh.",
    "wallet.institutional.title": "Đăng ký ví lưu ký tổ chức",
    "wallet.institutional.uploadFile": "Tải lên tệp chứng thực",
    "wallet.institutional.uploadRequired":
      "Vui lòng tải lên tài liệu chứng thực.",
    "wallet.safe.address": "Địa chỉ Safe",
    "wallet.safe.chain": "Mạng lưới",
    "wallet.safe.connectFirst": "Vui lòng kết nối ví ký của bạn trước.",
    "wallet.safe.connectSigner": "Kết nối ví ký",
    "wallet.safe.createNew": "Tạo Safe mới",
    "wallet.safe.createNewDesc":
      "Mở app.safe.global nơi bạn có thể tạo ví đa chữ ký mới. Quay lại đây sau khi đã triển khai xong.",
    "wallet.safe.haveOne": "Tôi đã có một Safe",
    "wallet.safe.haveOneDesc":
      "Nhập địa chỉ Safe của bạn và xác minh quyền kiểm soát bằng cách ký một thông báo từ ví ký.",
    "wallet.safe.invalidAddress":
      "Vui lòng nhập địa chỉ Ethereum hợp lệ (0x...)",
    "wallet.safe.rejected": "Yêu cầu ký đã bị từ chối.",
    "wallet.safe.signError":
      "Ký thông báo xác minh không thành công. Vui lòng thử lại.",
    "wallet.safe.signVerify": "Ký để xác minh quyền kiểm soát",
    "wallet.safe.signerWallet": "Ví ký",
    "wallet.safe.subtitle":
      "Safe yêu cầu nhiều người ký để phê duyệt mỗi giao dịch, mang lại mức độ bảo mật cao nhất cho quỹ của tổ chức từ thiện của bạn.",
    "wallet.safe.title": "Thiết lập ví đa chữ ký Safe",
    "wallet.safe.verifyTitle": "Xác minh quyền sở hữu Safe",
    "wallet.safe.verifying": "Đang xác minh...",
    "wallet.setup.addAnother": "Thêm ví khác",
    "wallet.setup.custodian": "Đơn vị lưu ký",
    "wallet.setup.deleteFailed": "Xóa ví không thành công",
    "wallet.setup.eoaDesc":
      "Ví tiêu chuẩn được kiểm soát bởi một khóa riêng tư. Đơn giản nhất nhưng kém an toàn nhất cho mục đích sử dụng của tổ chức.",
    "wallet.setup.eoaTitle": "Một chữ ký (EOA)",
    "wallet.setup.institutionalDesc":
      "Được quản lý bởi đơn vị lưu ký đủ điều kiện (Fireblocks, Anchorage, v.v.). Yêu cầu tài liệu chứng thực.",
    "wallet.setup.institutionalTitle": "Lưu ký tổ chức",
    "wallet.setup.makePrimary": "Đặt làm ví chính",
    "wallet.setup.primary": "Chính",
    "wallet.setup.primaryFailed": "Cập nhật ví chính không thành công",
    "wallet.setup.primaryUpdated": "Đã cập nhật ví chính",
    "wallet.setup.recommended": "Được đề xuất",
    "wallet.setup.remove": "Xóa ví",
    "wallet.setup.safeDesc":
      "Yêu cầu nhiều người ký cho mỗi giao dịch. Bảo mật cao nhất cho quỹ của tổ chức.",
    "wallet.setup.safeSigners": "Người ký",
    "wallet.setup.safeTitle": "Safe đa chữ ký",
    "wallet.setup.subtitle":
      "Chọn cách tổ chức từ thiện của bạn sẽ nhận quyên góp tiền mã hóa. Chúng tôi khuyến nghị ví đa chữ ký để đảm bảo an toàn tối đa.",
    "wallet.setup.title": "Thiết lập ví nhận của bạn",
    "wallet.setup.viewExplorer": "Xem trên trình khám phá khối",
    "wallet.setup.walletAdded": "Đăng ký ví thành công",
    "wallet.setup.walletDeleted": "Đã xóa ví",
    "wallet.setup.walletsTitle": "Ví nhận quyên góp",
    "admin.nav.dashboard": "Bảng điều khiển",
    "admin.nav.reports": "Báo cáo & Phân tích",
    "admin.nav.charities": "Tổ chức từ thiện",
    "admin.nav.donations": "Quyên góp",
    "admin.nav.impactMetrics": "Chỉ số tác động",
    "admin.nav.portfolioFunds": "Quỹ danh mục",
    "admin.nav.contentModeration": "Kiểm duyệt nội dung",
    "admin.nav.settings": "Cài đặt hệ thống",
    "admin.nav.overview": "Tổng quan",
    "admin.nav.operations": "Vận hành",
    "admin.nav.consoleLabel": "Bảng điều khiển quản trị",
    "admin.shell.searchPlaceholder":
      "Tìm kiếm nhà tài trợ, tổ chức từ thiện, mã giao dịch…",
    "admin.shell.searchLabel": "Tìm kiếm trong bảng điều khiển quản trị",
    "admin.shell.notifications": "Thông báo",
    "admin.shell.adminLabel": "quản trị viên",
    "admin.shell.superAdmin": "Quản trị viên cấp cao",
    "admin.shell.signOut": "Đăng xuất",
    "admin.shell.backToPublicSite": "Quay lại trang công khai",
    "admin.shell.homeLink": "Trang chủ Give Protocol",
    "admin.dashboard.severityHigh": "Ưu tiên cao",
    "admin.dashboard.severityMedium": "Cần chú ý",
    "admin.dashboard.severityLow": "Cần xem xét",
    "admin.dashboard.alertOldest": "Yêu cầu cũ nhất đã được gửi",
    "admin.dashboard.alertReviewHint": "xem xét để duy trì tiến độ tiếp nhận",
    "admin.dashboard.reviewQueue": "Hàng đợi xem xét",
    "admin.dashboard.kpiDonorsSub": "{{count}} mới trong 30 ngày qua",
    "admin.dashboard.kpiPending": "{{count}} đang chờ xử lý",
    "admin.dashboard.awaitingVerification": "Đang chờ xác minh",
    "admin.dashboard.kpiVerifiedSub":
      "trên tổng số {{total}} đã được phê duyệt",
    "admin.dashboard.kpiVolunteersActive": "Lượt đăng ký đang hoạt động",
    "admin.dashboard.kpiVolunteersSub":
      "Không có lượt đăng ký nào đang hoạt động",
    "admin.dashboard.donationVolume": "Khối lượng quyên góp",
    "admin.dashboard.donationVolumeSub":
      "{{range}} · kết hợp tiền mã hóa + tiền pháp định",
    "admin.dashboard.range30d": "30 ngày qua",
    "admin.dashboard.range90d": "90 ngày qua",
    "admin.dashboard.rangeYtd": "Từ đầu năm đến nay",
    "admin.dashboard.volumeEmptyTitle":
      "Chưa có khoản quyên góp nào được ghi nhận",
    "admin.dashboard.volumeEmptySub":
      "Khối lượng sẽ được hiển thị trên biểu đồ ngay khi khoản quyên góp đầu tiên được xác nhận",
    "admin.dashboard.totalVolume": "Tổng khối lượng",
    "admin.dashboard.crypto": "Tiền mã hóa",
    "admin.dashboard.fiat": "Tiền pháp định",
    "admin.dashboard.activitySubtitle":
      "Các sự kiện trên nền tảng khi chúng xảy ra",
    "admin.dashboard.viewAllActivity": "Xem tất cả hoạt động",
    "admin.dashboard.viewAllDonations": "Xem tất cả khoản quyên góp",
    "admin.charity.tabAll": "Tất cả",
    "admin.charity.review": "Xem xét",
    "admin.charity.colOrganization": "Tổ chức",
    "admin.charity.colRaised": "Đã quyên góp được",
    "admin.charity.colSubmitted": "Đã gửi",
    "admin.charity.searchAria": "Tìm kiếm tổ chức từ thiện",
    "admin.charity.reviewTitle": "Xem xét {{name}}",
    "admin.charity.submittedRelative": "Đã gửi {{when}}",
    "admin.charity.contactEmail": "Email",
    "admin.charity.contactPhone": "Điện thoại",
    "admin.charity.raisedUnavailable": "Không có tổng số quyên góp",
    "admin.error.title": "Lỗi tải dữ liệu",
    "admin.error.recentActivity": "Lỗi tải hoạt động gần đây",
    "admin.error.alerts": "Lỗi tải cảnh báo",
    "admin.error.donationVolume": "Lỗi tải khối lượng quyên góp",
    "donation.gas.estimating": "Đang ước tính phí mạng…",
    "donation.gas.label": "Phí mạng ước tính",
    "donation.gas.highGasWarning":
      "Cảnh báo phí gas cao: phí ước tính là {{usd}}, chiếm {{pct}} khoản quyên góp của bạn.",
    "donation.gas.highGasSuggestion":
      "Hãy cân nhắc quyên góp số tiền lớn hơn hoặc chuyển sang chuỗi có phí thấp hơn.",
    "donation.gas.l2Hint": "Để có phí thấp hơn, hãy thử {{chains}}.",
  },
};
